import { compareTo3ankvs086tmwq as compareTo } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  abs22kdeprm0tm5i as abs,
  roundToLong2s902lrwaad4n as roundToLong,
} from '../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
  toNumber2e2hj9zugjwi2 as toNumber,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  multiply2k9eolhnz1bjv as multiply,
  negate13xrbakfwasjy as negate,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  reversed3umwqsxpi431x as reversed,
  chunked3v1tthtda414w as chunked,
  take9j4462mea726 as take,
} from '../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  reversed22y3au42jl32b as reversed_0,
  joinToString1cxrrlmo0chqs as joinToString,
  getOrNull1go7ef9ldk0df as getOrNull,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  padStart36w1507hs626a as padStart,
  isBlank1dvkhjjvox3p0 as isBlank,
  trim11nh7r46at6sx as trim,
  startsWith1bgirhbedtv2y as startsWith,
  split3d3yeauc4rm2n as split,
} from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { toLongOrNullutqivezb0wx1 as toLongOrNull } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import {
  LongSerializer_getInstance194e4t3ow5wjs as LongSerializer_getInstance,
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  ServerFile__toString_impl_4rulpa1zv5xkbnowbd9 as ServerFile__toString_impl_4rulpa,
  ServerFile__hashCode_impl_qj0ii515d8xjm2d7n5l as ServerFile__hashCode_impl_qj0ii5,
} from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  $serializer_getInstance2yxo5k0co7dg6 as $serializer_getInstance,
  LineItem2rt64afaiyloc as LineItem,
  Incident3aojs8cp7629c as Incident,
  $serializer_getInstancer4f83meamevp as $serializer_getInstance_0,
  $serializer_getInstance3sf4q4nbunlsv as $serializer_getInstance_1,
  $serializer_getInstance28bv3p4ron8x8 as $serializer_getInstance_2,
  $serializer_getInstance2hd22g62jocd3 as $serializer_getInstance_3,
  $serializer_getInstance1vmv5e6k1823y as $serializer_getInstance_4,
  User8yb1tqk4kykg as User,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
  Contractor1wog4uk4l8u77 as Contractor,
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  ScopeView2pjeasrtqdymw as ScopeView,
} from './databaseModels.mjs';
import { $serializer_getInstancestor8ej9dr0n as $serializer_getInstance_5 } from '../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/proofModels.mjs';
import {
  Instant3cn81rq2kpflk as Instant,
  Companion_getInstance3vjikuur3h0k4 as Companion_getInstance,
} from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { References1cc2ge45k8vol as References } from '../../../lightning-server-shared/com/lightningkite/lightningdb/Annotations.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { NotificationContent14rxxdz7igy9l as NotificationContent } from './notifications/shared.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import {
  EmailAddressSerializer_getInstanceu3ltgmcd8ai as EmailAddressSerializer_getInstance,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
  EmailAddress__toString_impl_artjh32mgb4pan49acs as EmailAddress__toString_impl_artjh3,
  EmailAddress__hashCode_impl_wizg9y17d6wnfa2ztdr as EmailAddress__hashCode_impl_wizg9y,
  _EmailAddress___get_raw__impl__6ose21hsaqj8b5ou10 as _EmailAddress___get_raw__impl__6ose2,
} from '../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Companion_getInstance9bswgra0rac8 as Companion_getInstance_1,
  Companion_getInstance1i8v5a4alj7fe as Companion_getInstance_2,
  State_Utah_getInstance3mij6nisrv8ix as State_Utah_getInstance,
  Companion_getInstance30zv25jlmpi4e as Companion_getInstance_3,
} from './enums.mjs';
import { SharedUtils_getInstanceggolgle4lzs6 as SharedUtils_getInstance } from './sharedUtils.mjs';
import { LongRange138sb2ngfio7d as LongRange } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/PrimitiveRanges.mjs';
import {
  ClosedRangehokgr73im9z3 as ClosedRange,
  OpenEndRange1a2my95ycmxk8 as OpenEndRange,
} from '../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { Iterable1y3qizuf89iou as Iterable } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { ReadByDataModel1nk4gz5mxza5s as ReadByDataModel } from './readReceipts.mjs';
import { combineWith38f9w17ugug7w as combineWith } from './extensions/UUID.ext.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _MonetaryValue___init__impl__jsc11x(inUsCents) {
  return inUsCents;
}
function _MonetaryValue___get_inUsCents__impl__icg2cu($this) {
  return $this;
}
function MonetaryValue__compareTo_impl_w7ul1r($this, other) {
  return compareTo(_MonetaryValue___get_inUsCents__impl__icg2cu($this), _MonetaryValue___get_inUsCents__impl__icg2cu(other));
}
function MonetaryValue__compareTo_impl_w7ul1r_0($this, other) {
  return MonetaryValue__compareTo_impl_w7ul1r($this.a5s_1, other instanceof MonetaryValue() ? other.a5s_1 : THROW_CCE());
}
function MonetaryValue__toString_impl_xslc77($this) {
  // Inline function 'com.crowpay.MonetaryValue.toDollarsAndCents' call
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  // Inline function 'kotlin.Long.div' call
  var this_1 = abs(this_0);
  var tmp0 = divide(this_1, fromInt(100));
  // Inline function 'kotlin.math.absoluteValue' call
  var this_2 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  // Inline function 'kotlin.Long.rem' call
  var this_3 = abs(this_2);
  var tmp2 = modulo(this_3, fromInt(100));
  var negative = _MonetaryValue___get_inUsCents__impl__icg2cu($this) < 0n;
  // Inline function 'kotlin.text.reversed' call
  var this_4 = tmp0.toString();
  var tmp = toString(reversed(isCharSequence(this_4) ? this_4 : THROW_CCE()));
  var dollars = joinToString(reversed_0(chunked(tmp, 3, MonetaryValue$toString$lambda)), ',');
  var tmp_0;
  if (tmp2 === 0n) {
    tmp_0 = '$' + dollars;
  } else {
    var cents = padStart(tmp2.toString(), 2, _Char___init__impl__6a9atx(48));
    tmp_0 = '$' + dollars + '.' + cents;
  }
  var str = tmp_0;
  return negative ? '-' + str : str;
}
function MonetaryValue__toStringAbsolute_impl_uovmiu($this) {
  // Inline function 'com.crowpay.MonetaryValue.toDollarsAndCents' call
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  // Inline function 'kotlin.Long.div' call
  var this_1 = abs(this_0);
  var tmp0 = divide(this_1, fromInt(100));
  // Inline function 'kotlin.math.absoluteValue' call
  var this_2 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  // Inline function 'kotlin.Long.rem' call
  var this_3 = abs(this_2);
  var tmp2 = modulo(this_3, fromInt(100));
  _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  // Inline function 'kotlin.text.reversed' call
  var this_4 = tmp0.toString();
  var tmp = toString(reversed(isCharSequence(this_4) ? this_4 : THROW_CCE()));
  var dollars = joinToString(reversed_0(chunked(tmp, 3, MonetaryValue$toStringAbsolute$lambda)), ',');
  var tmp_0;
  if (tmp2 === 0n) {
    tmp_0 = '$' + dollars;
  } else {
    var cents = padStart(tmp2.toString(), 2, _Char___init__impl__6a9atx(48));
    tmp_0 = '$' + dollars + '.' + cents;
  }
  return tmp_0;
}
function MonetaryValue__toFullString_impl_igjjwy($this) {
  // Inline function 'com.crowpay.MonetaryValue.toDollarsAndCents' call
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  // Inline function 'kotlin.Long.div' call
  var this_1 = abs(this_0);
  var tmp0 = divide(this_1, fromInt(100));
  // Inline function 'kotlin.math.absoluteValue' call
  var this_2 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  // Inline function 'kotlin.Long.rem' call
  var this_3 = abs(this_2);
  var tmp2 = modulo(this_3, fromInt(100));
  var negative = _MonetaryValue___get_inUsCents__impl__icg2cu($this) < 0n;
  // Inline function 'kotlin.text.reversed' call
  var this_4 = tmp0.toString();
  var tmp = toString(reversed(isCharSequence(this_4) ? this_4 : THROW_CCE()));
  var dollars = joinToString(reversed_0(chunked(tmp, 3, MonetaryValue$toFullString$lambda)), ',');
  var cents = padStart(tmp2.toString(), 2, _Char___init__impl__6a9atx(48));
  var str = '$' + dollars + '.' + cents;
  return negative ? '-' + str : str;
}
function _MonetaryValue___get_inUsDollars__impl__m6itgm($this) {
  // Inline function 'kotlin.Long.div' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  return toNumber(this_0) / 100.0;
}
function _MonetaryValue___get_absoluteValue__impl__hjldkw($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  var tmp$ret$0 = abs(this_0);
  return _MonetaryValue___init__impl__jsc11x(tmp$ret$0);
}
function MonetaryValue__plus_impl_c1ylt($this, other) {
  return _MonetaryValue___init__impl__jsc11x(add(_MonetaryValue___get_inUsCents__impl__icg2cu($this), _MonetaryValue___get_inUsCents__impl__icg2cu(other)));
}
function MonetaryValue__minus_impl_jw9qyp($this, other) {
  return _MonetaryValue___init__impl__jsc11x(subtract(_MonetaryValue___get_inUsCents__impl__icg2cu($this), _MonetaryValue___get_inUsCents__impl__icg2cu(other)));
}
function MonetaryValue__times_impl_hlr6p7($this, other) {
  // Inline function 'kotlin.Long.times' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  var tmp$ret$0 = multiply(this_0, fromInt(other));
  return _MonetaryValue___init__impl__jsc11x(tmp$ret$0);
}
function MonetaryValue__times_impl_hlr6p7_0($this, other) {
  // Inline function 'kotlin.Long.times' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  // Inline function 'kotlin.math.roundToLong' call
  var this_1 = toNumber(this_0) * other;
  var tmp$ret$1 = roundToLong(this_1);
  return _MonetaryValue___init__impl__jsc11x(tmp$ret$1);
}
function MonetaryValue__times_impl_hlr6p7_1($this, other) {
  // Inline function 'kotlin.Long.times' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  var tmp$ret$0 = toNumber(this_0) * other;
  return _MonetaryValue___init__impl__jsc11x(roundToLong(tmp$ret$0));
}
function MonetaryValue__div_impl_3meibk($this, other) {
  // Inline function 'kotlin.Long.div' call
  var this_0 = _MonetaryValue___get_inUsCents__impl__icg2cu($this);
  var tmp$ret$0 = divide(this_0, fromInt(other));
  return _MonetaryValue___init__impl__jsc11x(tmp$ret$0);
}
function MonetaryValue__unaryMinus_impl_x5smq0($this) {
  return _MonetaryValue___init__impl__jsc11x(negate(_MonetaryValue___get_inUsCents__impl__icg2cu($this)));
}
function MonetaryValue__div_impl_3meibk_0($this, other) {
  return toNumber(_MonetaryValue___get_inUsCents__impl__icg2cu($this)) / toNumber(_MonetaryValue___get_inUsCents__impl__icg2cu(other));
}
function MonetaryValue__rangeTo_impl_1k0odj($this, other) {
  return _MonetaryValueRange___init__impl__nk1fnc_0($this, other);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      p91(_this__u8e3s4) {
        return _MonetaryValue___init__impl__jsc11x(_this__u8e3s4);
      }
      o62(_this__u8e3s4) {
        return _MonetaryValue___init__impl__jsc11x(fromInt(_this__u8e3s4));
      }
      s9s(_this__u8e3s4) {
        return _MonetaryValue___init__impl__jsc11x(roundToLong(_this__u8e3s4));
      }
      t9s(_this__u8e3s4) {
        // Inline function 'kotlin.Long.times' call
        var tmp$ret$0 = multiply(_this__u8e3s4, fromInt(100));
        return _MonetaryValue___init__impl__jsc11x(tmp$ret$0);
      }
      n9s(_this__u8e3s4) {
        // Inline function 'kotlin.Long.times' call
        var this_0 = fromInt(_this__u8e3s4);
        var tmp$ret$0 = multiply(this_0, fromInt(100));
        return _MonetaryValue___init__impl__jsc11x(tmp$ret$0);
      }
      u9s(string) {
        if (isBlank(string))
          return null;
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$0 = toString(trim(isCharSequence(string) ? string : THROW_CCE()));
        var negative = startsWith(tmp$ret$0, _Char___init__impl__6a9atx(45));
        // Inline function 'kotlin.text.filter' call
        // Inline function 'kotlin.text.filterTo' call
        var destination = StringBuilder().d1();
        var inductionVariable = 0;
        var last = charSequenceLength(string);
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = charSequenceGet(string, index);
            if (isDigit(element) || element === _Char___init__impl__6a9atx(46)) {
              destination.xb(element);
            }
          }
           while (inductionVariable < last);
        var tmp$ret$3 = destination.toString();
        var units = split(tmp$ret$3, charArrayOf([_Char___init__impl__6a9atx(46)]));
        var containsArg = units.p1();
        if (!(1 <= containsArg ? containsArg <= 2 : false))
          return null;
        // Inline function 'kotlin.let' call
        var it = units.q1(0);
        var tmp;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(it) === 0) {
          tmp_0 = units.p1() === 2;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = Companion_instance_0.n9s(0);
        } else {
          var tmp0_safe_receiver = toLongOrNull(it);
          tmp = tmp0_safe_receiver == null ? null : Companion_instance_0.t9s(tmp0_safe_receiver);
        }
        var tmp_1 = tmp;
        var tmp_2 = tmp_1 == null ? null : new (MonetaryValue())(tmp_1);
        var tmp0_elvis_lhs = tmp_2 == null ? null : tmp_2.a5s_1;
        var tmp_3;
        var tmp_4 = tmp0_elvis_lhs;
        if ((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null) {
          return null;
        } else {
          tmp_3 = tmp0_elvis_lhs;
        }
        var dollars = tmp_3;
        var tmp1_safe_receiver = getOrNull(units, 1);
        var tmp_5;
        if (tmp1_safe_receiver == null) {
          tmp_5 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_6;
          if (!isBlank(tmp1_safe_receiver)) {
            tmp_6 = tmp1_safe_receiver;
          } else {
            tmp_6 = null;
          }
          tmp_5 = tmp_6;
        }
        var tmp2_safe_receiver = tmp_5;
        var tmp_7;
        if (tmp2_safe_receiver == null) {
          tmp_7 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = toLongOrNull(take(tmp2_safe_receiver, 2));
          var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : Companion_instance_0.p91(tmp0_safe_receiver_0);
          var tmp_8;
          var tmp_9 = tmp1_elvis_lhs;
          if ((tmp_9 == null ? null : new (MonetaryValue())(tmp_9)) == null) {
            return null;
          } else {
            tmp_8 = tmp1_elvis_lhs;
          }
          var result = tmp_8;
          tmp_7 = tmp2_safe_receiver.length === 1 ? MonetaryValue__times_impl_hlr6p7(result, 10) : result;
        }
        var tmp3_elvis_lhs = tmp_7;
        var tmp_10;
        var tmp_11 = tmp3_elvis_lhs;
        if ((tmp_11 == null ? null : new (MonetaryValue())(tmp_11)) == null) {
          tmp_10 = this.p91(0n);
        } else {
          tmp_10 = tmp3_elvis_lhs;
        }
        var cents = tmp_10;
        return negative ? MonetaryValue__unaryMinus_impl_x5smq0(MonetaryValue__plus_impl_c1ylt(dollars, cents)) : MonetaryValue__plus_impl_c1ylt(dollars, cents);
      }
      m2a() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_4() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.crowpay.MonetaryValue', this);
        tmp0_serialDesc.c1b('inUsCents', false);
        this.v9s_1 = tmp0_serialDesc;
      }
      w9s(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.v9s_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.l14(_MonetaryValue___get_inUsCents__impl__icg2cu(value));
        }
      }
      oz(encoder, value) {
        return this.w9s(encoder, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      x9s(decoder) {
        return _MonetaryValue___init__impl__jsc11x(decoder.j13(this.v9s_1).d13());
      }
      pz(decoder) {
        return new (MonetaryValue())(this.x9s(decoder));
      }
      az() {
        return this.v9s_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LongSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_6() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function MonetaryValue__hashCode_impl_fhcsz2($this) {
  return getBigIntHashCode($this);
}
function MonetaryValue__equals_impl_roomeu($this, other) {
  if (!(other instanceof MonetaryValue()))
    return false;
  if (!($this === other.a5s_1))
    return false;
  return true;
}
function MonetaryValue$toString$lambda(it) {
  return reversed(it);
}
function MonetaryValue$toStringAbsolute$lambda(it) {
  return reversed(it);
}
function MonetaryValue$toFullString$lambda(it) {
  return reversed(it);
}
var MonetaryValueClass;
function MonetaryValue() {
  if (MonetaryValueClass === VOID) {
    class $ {
      constructor(inUsCents) {
        this.a5s_1 = inUsCents;
      }
      y9s(other) {
        return MonetaryValue__compareTo_impl_w7ul1r(this.a5s_1, other);
      }
      d(other) {
        return MonetaryValue__compareTo_impl_w7ul1r_0(this, other);
      }
      toString() {
        return MonetaryValue__toString_impl_xslc77(this.a5s_1);
      }
      hashCode() {
        return MonetaryValue__hashCode_impl_fhcsz2(this.a5s_1);
      }
      equals(other) {
        return MonetaryValue__equals_impl_roomeu(this.a5s_1, other);
      }
    }
    initMetadataForClass($, 'MonetaryValue', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_6});
    MonetaryValueClass = $;
  }
  return MonetaryValueClass;
}
function ProjectAttachment$Companion$$childSerializers$_anonymous__wp7rua() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function ProjectAttachment$Companion$$childSerializers$_anonymous__wp7rua_0() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectAttachment$Companion$$childSerializers$_anonymous__wp7rua);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.p79_1 = [null, null, tmp_1, lazy(tmp_2, ProjectAttachment$Companion$$childSerializers$_anonymous__wp7rua_0)];
      }
      m2a() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_5() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ProjectAttachment', this, 4);
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('fileType', false);
        tmp0_serialDesc.c1b('file', false);
        tmp0_serialDesc.c1b('preview', true);
        this.z9s_1 = tmp0_serialDesc;
      }
      a9t(encoder, value) {
        var tmp0_desc = this.z9s_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_5().p79_1;
        tmp1_output.a15(tmp0_desc, 0, value.u79_1);
        tmp1_output.a15(tmp0_desc, 1, value.v79_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), new (ServerFile())(value.w79_1));
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 3)) {
          tmp = true;
        } else {
          var tmp_0 = value.x79_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = tmp2_cached[3].f2();
          var tmp_2 = value.x79_1;
          tmp1_output.d15(tmp0_desc, 3, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a9t(encoder, value instanceof ProjectAttachment() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z9s_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_5().p79_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp = tmp9_cached[2].f2();
          var tmp_0 = tmp6_local2;
          var tmp_1 = tmp8_input.x13(tmp0_desc, 2, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp6_local2 = tmp_1 == null ? null : tmp_1.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp_2 = tmp9_cached[3].f2();
          var tmp_3 = tmp7_local3;
          var tmp_4 = tmp8_input.z13(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
          tmp7_local3 = tmp_4 == null ? null : tmp_4.n2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_5 = tmp9_cached[2].f2();
                var tmp_6 = tmp6_local2;
                var tmp_7 = tmp8_input.x13(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
                tmp6_local2 = tmp_7 == null ? null : tmp_7.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_8 = tmp9_cached[3].f2();
                var tmp_9 = tmp7_local3;
                var tmp_10 = tmp8_input.z13(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new (ServerFile())(tmp_9));
                tmp7_local3 = tmp_10 == null ? null : tmp_10.n2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return ProjectAttachment().b9t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.z9s_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_5().p79_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2(), get_nullable(tmp0_cached[3].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_7() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var ProjectAttachmentClass;
function ProjectAttachment() {
  if (ProjectAttachmentClass === VOID) {
    class $ {
      constructor(name, fileType, file, preview) {
        Companion_getInstance_5();
        preview = preview === VOID ? null : preview;
        this.u79_1 = name;
        this.v79_1 = fileType;
        this.w79_1 = file;
        this.x79_1 = preview;
      }
      k20() {
        return this.u79_1;
      }
      f93() {
        return this.v79_1;
      }
      g93() {
        return this.w79_1;
      }
      h93() {
        return this.x79_1;
      }
      c9t(name, fileType, file, preview) {
        return new (ProjectAttachment())(name, fileType, file, preview);
      }
      z79(name, fileType, file, preview, $super) {
        name = name === VOID ? this.u79_1 : name;
        fileType = fileType === VOID ? this.v79_1 : fileType;
        file = file === VOID ? this.w79_1 : file;
        preview = preview === VOID ? this.x79_1 : preview;
        var tmp;
        if ($super === VOID) {
          tmp = this.c9t(name, fileType, file, preview);
        } else {
          var tmp_0 = $super.c9t;
          var tmp_1 = preview;
          tmp = tmp_0.call(this, name, fileType, new (ServerFile())(file), tmp_1 == null ? null : new (ServerFile())(tmp_1));
        }
        return tmp;
      }
      toString() {
        var tmp = ServerFile__toString_impl_4rulpa(this.w79_1);
        var tmp_0 = this.x79_1;
        return 'ProjectAttachment(name=' + this.u79_1 + ', fileType=' + this.v79_1 + ', file=' + tmp + ', preview=' + toString_0(tmp_0 == null ? null : new (ServerFile())(tmp_0)) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.u79_1);
        result = imul(result, 31) + getStringHashCode(this.v79_1) | 0;
        result = imul(result, 31) + ServerFile__hashCode_impl_qj0ii5(this.w79_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.x79_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.x79_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectAttachment()))
          return false;
        if (!(this.u79_1 === other.u79_1))
          return false;
        if (!(this.v79_1 === other.v79_1))
          return false;
        if (!(this.w79_1 === other.w79_1))
          return false;
        var tmp = this.x79_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.x79_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        return true;
      }
      static b9t(seen0, name, fileType, file, preview, serializationConstructorMarker) {
        Companion_getInstance_5();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_7().z9s_1);
        }
        var $this = createThis(this);
        $this.u79_1 = name;
        $this.v79_1 = fileType;
        $this.w79_1 = file;
        if (0 === (seen0 & 8))
          $this.x79_1 = null;
        else
          $this.x79_1 = preview;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectAttachment', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
    ProjectAttachmentClass = $;
  }
  return ProjectAttachmentClass;
}
function HashAndManyFeedback$Companion$$childSerializers$_anonymous__9wgjx9() {
  return new (ArrayListSerializer())($serializer_getInstance_20());
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h8s_1 = [null, lazy(tmp_0, HashAndManyFeedback$Companion$$childSerializers$_anonymous__9wgjx9)];
      }
      m2a() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_6() {
  if (Companion_instance_2 === VOID)
    new (Companion_1())();
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.HashAndManyFeedback', this, 2);
        tmp0_serialDesc.c1b('hash', false);
        tmp0_serialDesc.c1b('feedbacks', false);
        this.d9t_1 = tmp0_serialDesc;
      }
      e9t(encoder, value) {
        var tmp0_desc = this.d9t_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_6().h8s_1;
        tmp1_output.a15(tmp0_desc, 0, value.f9t_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.g9t_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e9t(encoder, value instanceof HashAndManyFeedback() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d9t_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_6().h8s_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return HashAndManyFeedback().h9t(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.d9t_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_6().h8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_8() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var HashAndManyFeedbackClass;
function HashAndManyFeedback() {
  if (HashAndManyFeedbackClass === VOID) {
    class $ {
      constructor(hash, feedbacks) {
        Companion_getInstance_6();
        this.f9t_1 = hash;
        this.g9t_1 = feedbacks;
      }
      toString() {
        return 'HashAndManyFeedback(hash=' + this.f9t_1 + ', feedbacks=' + toString(this.g9t_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.f9t_1);
        result = imul(result, 31) + hashCode(this.g9t_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HashAndManyFeedback()))
          return false;
        if (!(this.f9t_1 === other.f9t_1))
          return false;
        if (!equals(this.g9t_1, other.g9t_1))
          return false;
        return true;
      }
      static h9t(seen0, hash, feedbacks, serializationConstructorMarker) {
        Companion_getInstance_6();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_8().d9t_1);
        }
        var $this = createThis(this);
        $this.f9t_1 = hash;
        $this.g9t_1 = feedbacks;
        return $this;
      }
    }
    initMetadataForClass($, 'HashAndManyFeedback', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
    HashAndManyFeedbackClass = $;
  }
  return HashAndManyFeedbackClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.i8s_1.f2();
}
function DirectDeposit$DirectStatus$Companion$_anonymous__it1c6d() {
  return createSimpleEnumSerializer('com.crowpay.DirectDeposit.DirectStatus', values());
}
var DirectStatus_New_instance;
var DirectStatus_DescriptorVerification_instance;
var DirectStatus_AmountVerification_instance;
var DirectStatus_Failed_instance;
var DirectStatus_Verified_instance;
function values() {
  return [DirectStatus_New_getInstance(), DirectStatus_DescriptorVerification_getInstance(), DirectStatus_AmountVerification_getInstance(), DirectStatus_Failed_getInstance(), DirectStatus_Verified_getInstance()];
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.i8s_1 = lazy(tmp_0, DirectDeposit$DirectStatus$Companion$_anonymous__it1c6d);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_7() {
  DirectStatus_initEntries();
  if (Companion_instance_3 === VOID)
    new (Companion_2())();
  return Companion_instance_3;
}
var DirectStatus_entriesInitialized;
function DirectStatus_initEntries() {
  if (DirectStatus_entriesInitialized)
    return Unit_instance;
  DirectStatus_entriesInitialized = true;
  DirectStatus_New_instance = DirectStatus().k9t('New', 0);
  DirectStatus_DescriptorVerification_instance = DirectStatus().k9t('DescriptorVerification', 1);
  DirectStatus_AmountVerification_instance = DirectStatus().k9t('AmountVerification', 2);
  DirectStatus_Failed_instance = DirectStatus().k9t('Failed', 3);
  DirectStatus_Verified_instance = DirectStatus().k9t('Verified', 4);
  Companion_getInstance_7();
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.j8s_1.f2();
}
function DirectDeposit$OwnerStatus$Companion$_anonymous__rbwzmv() {
  return createSimpleEnumSerializer('com.crowpay.DirectDeposit.OwnerStatus', values_0());
}
var OwnerStatus_New_instance;
var OwnerStatus_Failed_instance;
var OwnerStatus_Canceled_instance;
var OwnerStatus_Success_instance;
function values_0() {
  return [OwnerStatus_New_getInstance(), OwnerStatus_Failed_getInstance(), OwnerStatus_Canceled_getInstance(), OwnerStatus_Success_getInstance()];
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.j8s_1 = lazy(tmp_0, DirectDeposit$OwnerStatus$Companion$_anonymous__rbwzmv);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_8() {
  OwnerStatus_initEntries();
  if (Companion_instance_4 === VOID)
    new (Companion_3())();
  return Companion_instance_4;
}
var OwnerStatus_entriesInitialized;
function OwnerStatus_initEntries() {
  if (OwnerStatus_entriesInitialized)
    return Unit_instance;
  OwnerStatus_entriesInitialized = true;
  OwnerStatus_New_instance = OwnerStatus().n9t('New', 0);
  OwnerStatus_Failed_instance = OwnerStatus().n9t('Failed', 1);
  OwnerStatus_Canceled_instance = OwnerStatus().n9t('Canceled', 2);
  OwnerStatus_Success_instance = OwnerStatus().n9t('Success', 3);
  Companion_getInstance_8();
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.k8s_1.f2();
}
function DirectDeposit$AdminVerification$Companion$_anonymous__5ftung() {
  return createSimpleEnumSerializer('com.crowpay.DirectDeposit.AdminVerification', values_1());
}
var AdminVerification_New_instance;
var AdminVerification_Rejected_instance;
var AdminVerification_Verified_instance;
function values_1() {
  return [AdminVerification_New_getInstance(), AdminVerification_Rejected_getInstance(), AdminVerification_Verified_getInstance()];
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.k8s_1 = lazy(tmp_0, DirectDeposit$AdminVerification$Companion$_anonymous__5ftung);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_9() {
  AdminVerification_initEntries();
  if (Companion_instance_5 === VOID)
    new (Companion_4())();
  return Companion_instance_5;
}
var AdminVerification_entriesInitialized;
function AdminVerification_initEntries() {
  if (AdminVerification_entriesInitialized)
    return Unit_instance;
  AdminVerification_entriesInitialized = true;
  AdminVerification_New_instance = AdminVerification().q9t('New', 0);
  AdminVerification_Rejected_instance = AdminVerification().q9t('Rejected', 1);
  AdminVerification_Verified_instance = AdminVerification().q9t('Verified', 2);
  Companion_getInstance_9();
}
function DirectDeposit$VerificationRequest$Companion$$childSerializers$_anonymous__95mm3() {
  return new (ArrayListSerializer())($serializer_getInstance_6());
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l8s_1 = [lazy(tmp_0, DirectDeposit$VerificationRequest$Companion$$childSerializers$_anonymous__95mm3), null];
      }
      m2a() {
        return $serializer_getInstance_9();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_10() {
  if (Companion_instance_6 === VOID)
    new (Companion_5())();
  return Companion_instance_6;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.DirectDeposit.VerificationRequest', this, 2);
        tmp0_serialDesc.c1b('amounts', true);
        tmp0_serialDesc.c1b('code', true);
        this.r9t_1 = tmp0_serialDesc;
      }
      s9t(encoder, value) {
        var tmp0_desc = this.r9t_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_10().l8s_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.t9t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, tmp2_cached[0].f2(), value.t9t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.u9t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.u9t_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s9t(encoder, value instanceof VerificationRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r9t_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_10().l8s_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.z13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.z13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return VerificationRequest().v9t(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.r9t_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_10().l8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(tmp0_cached[0].f2()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_9() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function DirectDeposit$Info$Companion$$childSerializers$_anonymous__indlsd() {
  return Companion_getInstance_9().m2a();
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.m8s_1 = [null, null, lazy(tmp_0, DirectDeposit$Info$Companion$$childSerializers$_anonymous__indlsd)];
      }
      m2a() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_11() {
  if (Companion_instance_7 === VOID)
    new (Companion_6())();
  return Companion_instance_7;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.DirectDeposit.Info', this, 3);
        tmp0_serialDesc.c1b('direct', false);
        tmp0_serialDesc.c1b('ownerInfo', false);
        tmp0_serialDesc.c1b('verified', false);
        this.w9t_1 = tmp0_serialDesc;
      }
      x9t(encoder, value) {
        var tmp0_desc = this.w9t_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_11().m8s_1;
        tmp1_output.d15(tmp0_desc, 0, $serializer_getInstance_14(), value.y9t_1);
        tmp1_output.d15(tmp0_desc, 1, $serializer_getInstance_13(), value.z9t_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.a9u_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x9t(encoder, value instanceof Info() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w9t_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_11().m8s_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, $serializer_getInstance_14(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, $serializer_getInstance_14(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return Info().b9u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.w9t_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_11().m8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_14()), get_nullable($serializer_getInstance_13()), tmp0_cached[2].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_10() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
function DirectDeposit$AdminInfo$Companion$$childSerializers$_anonymous__tkm0kc() {
  return new (ArrayListSerializer())($serializer_getInstance_12());
}
function DirectDeposit$AdminInfo$Companion$$childSerializers$_anonymous__tkm0kc_0() {
  return Companion_getInstance_9().m2a();
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, DirectDeposit$AdminInfo$Companion$$childSerializers$_anonymous__tkm0kc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n8s_1 = [null, null, null, tmp_1, lazy(tmp_2, DirectDeposit$AdminInfo$Companion$$childSerializers$_anonymous__tkm0kc_0)];
      }
      m2a() {
        return $serializer_getInstance_11();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_12() {
  if (Companion_instance_8 === VOID)
    new (Companion_7())();
  return Companion_instance_8;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.DirectDeposit.AdminInfo', this, 5);
        tmp0_serialDesc.c1b('bankName', false);
        tmp0_serialDesc.c1b('displayName', false);
        tmp0_serialDesc.c1b('last4', false);
        tmp0_serialDesc.c1b('owners', false);
        tmp0_serialDesc.c1b('verified', false);
        this.c9u_1 = tmp0_serialDesc;
      }
      d9u(encoder, value) {
        var tmp0_desc = this.c9u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_12().n8s_1;
        tmp1_output.a15(tmp0_desc, 0, value.e9u_1);
        tmp1_output.a15(tmp0_desc, 1, value.f9u_1);
        tmp1_output.a15(tmp0_desc, 2, value.g9u_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.h9u_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.i9u_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d9u(encoder, value instanceof AdminInfo() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c9u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_12().n8s_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.x13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.x13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return AdminInfo().j9u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.c9u_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_12().n8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].f2(), tmp0_cached[4].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_11() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_12();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_9;
function Companion_getInstance_13() {
  return Companion_instance_9;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.DirectDeposit.AdminOwner', this, 4);
        tmp0_serialDesc.c1b('email', false);
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('phone', false);
        tmp0_serialDesc.c1b('address', false);
        this.k9u_1 = tmp0_serialDesc;
      }
      l9u(encoder, value) {
        var tmp0_desc = this.k9u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.m9u_1);
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.n9u_1);
        tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.o9u_1);
        tmp1_output.d15(tmp0_desc, 3, StringSerializer_getInstance(), value.p9u_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l9u(encoder, value instanceof AdminOwner() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k9u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return AdminOwner().q9u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.k9u_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_12() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
function DirectDeposit$Owner$Companion$$childSerializers$_anonymous__34ml2y() {
  return Companion_getInstance_8().m2a();
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      constructor() {
        Companion_instance_10 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o8s_1 = [null, null, lazy(tmp_0, DirectDeposit$Owner$Companion$$childSerializers$_anonymous__34ml2y)];
      }
      m2a() {
        return $serializer_getInstance_13();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_10;
function Companion_getInstance_14() {
  if (Companion_instance_10 === VOID)
    new (Companion_9())();
  return Companion_instance_10;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.DirectDeposit.Owner', this, 3);
        tmp0_serialDesc.c1b('bankName', false);
        tmp0_serialDesc.c1b('last4', false);
        tmp0_serialDesc.c1b('status', false);
        this.r9u_1 = tmp0_serialDesc;
      }
      s9u(encoder, value) {
        var tmp0_desc = this.r9u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_14().o8s_1;
        tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.t9u_1);
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.u9u_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.v9u_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s9u(encoder, value instanceof Owner() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r9u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_14().o8s_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return Owner().w9u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.r9u_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_14().o8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[2].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_13() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
function DirectDeposit$Direct$Companion$$childSerializers$_anonymous__y84pgu() {
  return Companion_getInstance_7().m2a();
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      constructor() {
        Companion_instance_11 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.p8s_1 = [null, null, null, lazy(tmp_0, DirectDeposit$Direct$Companion$$childSerializers$_anonymous__y84pgu)];
      }
      m2a() {
        return $serializer_getInstance_14();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_11;
function Companion_getInstance_15() {
  if (Companion_instance_11 === VOID)
    new (Companion_10())();
  return Companion_instance_11;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.DirectDeposit.Direct', this, 4);
        tmp0_serialDesc.c1b('bankName', false);
        tmp0_serialDesc.c1b('accountName', false);
        tmp0_serialDesc.c1b('last4', false);
        tmp0_serialDesc.c1b('status', false);
        this.x9u_1 = tmp0_serialDesc;
      }
      y9u(encoder, value) {
        var tmp0_desc = this.x9u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_15().p8s_1;
        tmp1_output.a15(tmp0_desc, 0, value.z9u_1);
        tmp1_output.a15(tmp0_desc, 1, value.a9v_1);
        tmp1_output.a15(tmp0_desc, 2, value.b9v_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.c9v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y9u(encoder, value instanceof Direct() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x9u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_15().p8s_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return Direct().d9v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.x9u_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_15().p8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_14() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var DirectStatusClass;
function DirectStatus() {
  if (DirectStatusClass === VOID) {
    class $ extends Enum() {
      static k9t(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'DirectStatus', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
    DirectStatusClass = $;
  }
  return DirectStatusClass;
}
var OwnerStatusClass;
function OwnerStatus() {
  if (OwnerStatusClass === VOID) {
    class $ extends Enum() {
      static n9t(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'OwnerStatus', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    OwnerStatusClass = $;
  }
  return OwnerStatusClass;
}
var AdminVerificationClass;
function AdminVerification() {
  if (AdminVerificationClass === VOID) {
    class $ extends Enum() {
      static q9t(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'AdminVerification', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
    AdminVerificationClass = $;
  }
  return AdminVerificationClass;
}
var VerificationRequestClass;
function VerificationRequest() {
  if (VerificationRequestClass === VOID) {
    class $ {
      constructor(amounts, code) {
        Companion_getInstance_10();
        amounts = amounts === VOID ? null : amounts;
        code = code === VOID ? null : code;
        this.t9t_1 = amounts;
        this.u9t_1 = code;
      }
      toString() {
        return 'VerificationRequest(amounts=' + toString_0(this.t9t_1) + ', code=' + this.u9t_1 + ')';
      }
      hashCode() {
        var result = this.t9t_1 == null ? 0 : hashCode(this.t9t_1);
        result = imul(result, 31) + (this.u9t_1 == null ? 0 : getStringHashCode(this.u9t_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VerificationRequest()))
          return false;
        if (!equals(this.t9t_1, other.t9t_1))
          return false;
        if (!(this.u9t_1 == other.u9t_1))
          return false;
        return true;
      }
      static v9t(seen0, amounts, code, serializationConstructorMarker) {
        Companion_getInstance_10();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_9().r9t_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.t9t_1 = null;
        else
          $this.t9t_1 = amounts;
        if (0 === (seen0 & 2))
          $this.u9t_1 = null;
        else
          $this.u9t_1 = code;
        return $this;
      }
    }
    initMetadataForClass($, 'VerificationRequest', VerificationRequest, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
    VerificationRequestClass = $;
  }
  return VerificationRequestClass;
}
var InfoClass;
function Info() {
  if (InfoClass === VOID) {
    class $ {
      toString() {
        return 'Info(direct=' + toString_0(this.y9t_1) + ', ownerInfo=' + toString_0(this.z9t_1) + ', verified=' + this.a9u_1.toString() + ')';
      }
      hashCode() {
        var result = this.y9t_1 == null ? 0 : this.y9t_1.hashCode();
        result = imul(result, 31) + (this.z9t_1 == null ? 0 : this.z9t_1.hashCode()) | 0;
        result = imul(result, 31) + this.a9u_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Info()))
          return false;
        if (!equals(this.y9t_1, other.y9t_1))
          return false;
        if (!equals(this.z9t_1, other.z9t_1))
          return false;
        if (!this.a9u_1.equals(other.a9u_1))
          return false;
        return true;
      }
      static b9u(seen0, direct, ownerInfo, verified, serializationConstructorMarker) {
        Companion_getInstance_11();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_10().w9t_1);
        }
        var $this = createThis(this);
        $this.y9t_1 = direct;
        $this.z9t_1 = ownerInfo;
        $this.a9u_1 = verified;
        return $this;
      }
    }
    initMetadataForClass($, 'Info', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
    InfoClass = $;
  }
  return InfoClass;
}
var AdminInfoClass;
function AdminInfo() {
  if (AdminInfoClass === VOID) {
    class $ {
      toString() {
        return 'AdminInfo(bankName=' + this.e9u_1 + ', displayName=' + this.f9u_1 + ', last4=' + this.g9u_1 + ', owners=' + toString(this.h9u_1) + ', verified=' + this.i9u_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.e9u_1);
        result = imul(result, 31) + getStringHashCode(this.f9u_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g9u_1) | 0;
        result = imul(result, 31) + hashCode(this.h9u_1) | 0;
        result = imul(result, 31) + this.i9u_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AdminInfo()))
          return false;
        if (!(this.e9u_1 === other.e9u_1))
          return false;
        if (!(this.f9u_1 === other.f9u_1))
          return false;
        if (!(this.g9u_1 === other.g9u_1))
          return false;
        if (!equals(this.h9u_1, other.h9u_1))
          return false;
        if (!this.i9u_1.equals(other.i9u_1))
          return false;
        return true;
      }
      static j9u(seen0, bankName, displayName, last4, owners, verified, serializationConstructorMarker) {
        Companion_getInstance_12();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance_11().c9u_1);
        }
        var $this = createThis(this);
        $this.e9u_1 = bankName;
        $this.f9u_1 = displayName;
        $this.g9u_1 = last4;
        $this.h9u_1 = owners;
        $this.i9u_1 = verified;
        return $this;
      }
    }
    initMetadataForClass($, 'AdminInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
    AdminInfoClass = $;
  }
  return AdminInfoClass;
}
var AdminOwnerClass;
function AdminOwner() {
  if (AdminOwnerClass === VOID) {
    class $ {
      toString() {
        return 'AdminOwner(email=' + this.m9u_1 + ', name=' + this.n9u_1 + ', phone=' + this.o9u_1 + ', address=' + this.p9u_1 + ')';
      }
      hashCode() {
        var result = this.m9u_1 == null ? 0 : getStringHashCode(this.m9u_1);
        result = imul(result, 31) + (this.n9u_1 == null ? 0 : getStringHashCode(this.n9u_1)) | 0;
        result = imul(result, 31) + (this.o9u_1 == null ? 0 : getStringHashCode(this.o9u_1)) | 0;
        result = imul(result, 31) + (this.p9u_1 == null ? 0 : getStringHashCode(this.p9u_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AdminOwner()))
          return false;
        if (!(this.m9u_1 == other.m9u_1))
          return false;
        if (!(this.n9u_1 == other.n9u_1))
          return false;
        if (!(this.o9u_1 == other.o9u_1))
          return false;
        if (!(this.p9u_1 == other.p9u_1))
          return false;
        return true;
      }
      static q9u(seen0, email, name, phone, address, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_12().k9u_1);
        }
        var $this = createThis(this);
        $this.m9u_1 = email;
        $this.n9u_1 = name;
        $this.o9u_1 = phone;
        $this.p9u_1 = address;
        return $this;
      }
    }
    initMetadataForClass($, 'AdminOwner', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
    AdminOwnerClass = $;
  }
  return AdminOwnerClass;
}
var OwnerClass;
function Owner() {
  if (OwnerClass === VOID) {
    class $ {
      toString() {
        return 'Owner(bankName=' + this.t9u_1 + ', last4=' + this.u9u_1 + ', status=' + this.v9u_1.toString() + ')';
      }
      hashCode() {
        var result = this.t9u_1 == null ? 0 : getStringHashCode(this.t9u_1);
        result = imul(result, 31) + (this.u9u_1 == null ? 0 : getStringHashCode(this.u9u_1)) | 0;
        result = imul(result, 31) + this.v9u_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Owner()))
          return false;
        if (!(this.t9u_1 == other.t9u_1))
          return false;
        if (!(this.u9u_1 == other.u9u_1))
          return false;
        if (!this.v9u_1.equals(other.v9u_1))
          return false;
        return true;
      }
      static w9u(seen0, bankName, last4, status, serializationConstructorMarker) {
        Companion_getInstance_14();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_13().r9u_1);
        }
        var $this = createThis(this);
        $this.t9u_1 = bankName;
        $this.u9u_1 = last4;
        $this.v9u_1 = status;
        return $this;
      }
    }
    initMetadataForClass($, 'Owner', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
    OwnerClass = $;
  }
  return OwnerClass;
}
var DirectClass;
function Direct() {
  if (DirectClass === VOID) {
    class $ {
      toString() {
        return 'Direct(bankName=' + this.z9u_1 + ', accountName=' + this.a9v_1 + ', last4=' + this.b9v_1 + ', status=' + this.c9v_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.z9u_1);
        result = imul(result, 31) + getStringHashCode(this.a9v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b9v_1) | 0;
        result = imul(result, 31) + this.c9v_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Direct()))
          return false;
        if (!(this.z9u_1 === other.z9u_1))
          return false;
        if (!(this.a9v_1 === other.a9v_1))
          return false;
        if (!(this.b9v_1 === other.b9v_1))
          return false;
        if (!this.c9v_1.equals(other.c9v_1))
          return false;
        return true;
      }
      static d9v(seen0, bankName, accountName, last4, status, serializationConstructorMarker) {
        Companion_getInstance_15();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_14().x9u_1);
        }
        var $this = createThis(this);
        $this.z9u_1 = bankName;
        $this.a9v_1 = accountName;
        $this.b9v_1 = last4;
        $this.c9v_1 = status;
        return $this;
      }
    }
    initMetadataForClass($, 'Direct', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
    DirectClass = $;
  }
  return DirectClass;
}
function DirectStatus_New_getInstance() {
  DirectStatus_initEntries();
  return DirectStatus_New_instance;
}
function DirectStatus_DescriptorVerification_getInstance() {
  DirectStatus_initEntries();
  return DirectStatus_DescriptorVerification_instance;
}
function DirectStatus_AmountVerification_getInstance() {
  DirectStatus_initEntries();
  return DirectStatus_AmountVerification_instance;
}
function DirectStatus_Failed_getInstance() {
  DirectStatus_initEntries();
  return DirectStatus_Failed_instance;
}
function DirectStatus_Verified_getInstance() {
  DirectStatus_initEntries();
  return DirectStatus_Verified_instance;
}
function OwnerStatus_New_getInstance() {
  OwnerStatus_initEntries();
  return OwnerStatus_New_instance;
}
function OwnerStatus_Failed_getInstance() {
  OwnerStatus_initEntries();
  return OwnerStatus_Failed_instance;
}
function OwnerStatus_Canceled_getInstance() {
  OwnerStatus_initEntries();
  return OwnerStatus_Canceled_instance;
}
function OwnerStatus_Success_getInstance() {
  OwnerStatus_initEntries();
  return OwnerStatus_Success_instance;
}
function AdminVerification_New_getInstance() {
  AdminVerification_initEntries();
  return AdminVerification_New_instance;
}
function AdminVerification_Rejected_getInstance() {
  AdminVerification_initEntries();
  return AdminVerification_Rejected_instance;
}
function AdminVerification_Verified_getInstance() {
  AdminVerification_initEntries();
  return AdminVerification_Verified_instance;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_12;
function Companion_getInstance_16() {
  return Companion_instance_12;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PaymentSetupRequest', this, 4);
        tmp0_serialDesc.c1b('bankName', false);
        tmp0_serialDesc.c1b('routingNumber', false);
        tmp0_serialDesc.c1b('accountNumber', false);
        tmp0_serialDesc.c1b('accountName', false);
        this.e9v_1 = tmp0_serialDesc;
      }
      f9v(encoder, value) {
        var tmp0_desc = this.e9v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.g9v_1);
        tmp1_output.v14(tmp0_desc, 1, value.h9v_1);
        tmp1_output.a15(tmp0_desc, 2, value.i9v_1);
        tmp1_output.a15(tmp0_desc, 3, value.j9v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.f9v(encoder, value instanceof PaymentSetupRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e9v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.q13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.q13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return PaymentSetupRequest().k9v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.e9v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_15() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
var PaymentSetupRequestClass;
function PaymentSetupRequest() {
  if (PaymentSetupRequestClass === VOID) {
    class $ {
      constructor(bankName, routingNumber, accountNumber, accountName) {
        this.g9v_1 = bankName;
        this.h9v_1 = routingNumber;
        this.i9v_1 = accountNumber;
        this.j9v_1 = accountName;
      }
      toString() {
        return 'PaymentSetupRequest(bankName=' + this.g9v_1 + ', routingNumber=' + this.h9v_1 + ', accountNumber=' + this.i9v_1 + ', accountName=' + this.j9v_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.g9v_1);
        result = imul(result, 31) + this.h9v_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.i9v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j9v_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PaymentSetupRequest()))
          return false;
        if (!(this.g9v_1 === other.g9v_1))
          return false;
        if (!(this.h9v_1 === other.h9v_1))
          return false;
        if (!(this.i9v_1 === other.i9v_1))
          return false;
        if (!(this.j9v_1 === other.j9v_1))
          return false;
        return true;
      }
      static k9v(seen0, bankName, routingNumber, accountNumber, accountName, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_15().e9v_1);
        }
        var $this = createThis(this);
        $this.g9v_1 = bankName;
        $this.h9v_1 = routingNumber;
        $this.i9v_1 = accountNumber;
        $this.j9v_1 = accountName;
        return $this;
      }
    }
    initMetadataForClass($, 'PaymentSetupRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
    PaymentSetupRequestClass = $;
  }
  return PaymentSetupRequestClass;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_13;
function Companion_getInstance_17() {
  return Companion_instance_13;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PendingCashOut', this, 2);
        tmp0_serialDesc.c1b('available', false);
        tmp0_serialDesc.c1b('pending', false);
        this.l9v_1 = tmp0_serialDesc;
      }
      m9v(encoder, value) {
        var tmp0_desc = this.l9v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_6(), new (MonetaryValue())(value.n9v_1));
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_6(), new (MonetaryValue())(value.o9v_1));
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m9v(encoder, value instanceof PendingCashOut() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l9v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          var tmp = $serializer_getInstance_6();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_6();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp6_input.x13(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_6();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp6_input.x13(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_8 = $serializer_getInstance_6();
                var tmp_9 = tmp5_local1;
                var tmp_10 = tmp6_input.x13(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
                tmp5_local1 = tmp_10 == null ? null : tmp_10.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PendingCashOut().p9v(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.l9v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_6(), $serializer_getInstance_6()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_16() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
var PendingCashOutClass;
function PendingCashOut() {
  if (PendingCashOutClass === VOID) {
    class $ {
      constructor(available, pending) {
        this.n9v_1 = available;
        this.o9v_1 = pending;
      }
      toString() {
        return 'PendingCashOut(available=' + MonetaryValue__toString_impl_xslc77(this.n9v_1) + ', pending=' + MonetaryValue__toString_impl_xslc77(this.o9v_1) + ')';
      }
      hashCode() {
        var result = MonetaryValue__hashCode_impl_fhcsz2(this.n9v_1);
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.o9v_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PendingCashOut()))
          return false;
        if (!(this.n9v_1 === other.n9v_1))
          return false;
        if (!(this.o9v_1 === other.o9v_1))
          return false;
        return true;
      }
      static p9v(seen0, available, pending, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_16().l9v_1);
        }
        var $this = createThis(this);
        $this.n9v_1 = available;
        $this.o9v_1 = pending;
        return $this;
      }
    }
    initMetadataForClass($, 'PendingCashOut', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
    PendingCashOutClass = $;
  }
  return PendingCashOutClass;
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_14;
function Companion_getInstance_18() {
  return Companion_instance_14;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.RegisterContractor', this, 2);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.c1b('proof', false);
        this.q9v_1 = tmp0_serialDesc;
      }
      r9v(encoder, value) {
        var tmp0_desc = this.q9v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance(), value.s9v_1);
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_5(), value.t9v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r9v(encoder, value instanceof RegisterContractor() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q9v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return RegisterContractor().u9v(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.q9v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance(), $serializer_getInstance_5()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_17() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
var RegisterContractorClass;
function RegisterContractor() {
  if (RegisterContractorClass === VOID) {
    class $ {
      constructor(contractor, proof) {
        this.s9v_1 = contractor;
        this.t9v_1 = proof;
      }
      toString() {
        return 'RegisterContractor(contractor=' + this.s9v_1.toString() + ', proof=' + this.t9v_1.toString() + ')';
      }
      hashCode() {
        var result = this.s9v_1.hashCode();
        result = imul(result, 31) + this.t9v_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RegisterContractor()))
          return false;
        if (!this.s9v_1.equals(other.s9v_1))
          return false;
        if (!this.t9v_1.equals(other.t9v_1))
          return false;
        return true;
      }
      static u9v(seen0, contractor, proof, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_17().q9v_1);
        }
        var $this = createThis(this);
        $this.s9v_1 = contractor;
        $this.t9v_1 = proof;
        return $this;
      }
    }
    initMetadataForClass($, 'RegisterContractor', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
    RegisterContractorClass = $;
  }
  return RegisterContractorClass;
}
function Credit$Companion$$childSerializers$_anonymous__j21vbj() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Credit$Companion$$childSerializers$_anonymous__j21vbj_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Credit$Companion$$childSerializers$_anonymous__j21vbj_1() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Credit$Companion$$childSerializers$_anonymous__j21vbj_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      constructor() {
        Companion_instance_15 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Credit$Companion$$childSerializers$_anonymous__j21vbj);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Credit$Companion$$childSerializers$_anonymous__j21vbj_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, Credit$Companion$$childSerializers$_anonymous__j21vbj_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t5q_1 = [null, tmp_1, tmp_3, tmp_5, null, null, lazy(tmp_6, Credit$Companion$$childSerializers$_anonymous__j21vbj_2)];
      }
      m2a() {
        return $serializer_getInstance_18();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_15;
function Companion_getInstance_19() {
  if (Companion_instance_15 === VOID)
    new (Companion_14())();
  return Companion_instance_15;
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Credit', this, 7);
        tmp0_serialDesc.c1b('amount', false);
        tmp0_serialDesc.c1b('timestamp', true);
        tmp0_serialDesc.c1b('lineItem', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('incident', true);
        tmp0_serialDesc.d1b(new (References())(getKClass(Incident())));
        tmp0_serialDesc.c1b('projectCreditGroup', true);
        tmp0_serialDesc.c1b('reason', true);
        tmp0_serialDesc.c1b('readBy', true);
        this.v9v_1 = tmp0_serialDesc;
      }
      w9v(encoder, value) {
        var tmp0_desc = this.v9v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_19().t5q_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_6(), new (MonetaryValue())(value.a5r_1));
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).d1m();
          tmp = !value.b5r_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.b5r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.c5r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.c5r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.d5r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.d5r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.e5r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, IntSerializer_getInstance(), value.e5r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.f5r_1 === '')) {
          tmp1_output.a15(tmp0_desc, 5, value.f5r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !equals(value.g5r_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.g5r_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.w9v(encoder, value instanceof Credit() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v9v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance_19().t5q_1;
        if (tmp11_input.a14()) {
          var tmp = $serializer_getInstance_6();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.z13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.z13(tmp0_desc, 3, tmp12_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.z13(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_6();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp11_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, tmp12_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.z13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.z13(tmp0_desc, 3, tmp12_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.z13(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return Credit().x9v(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.v9v_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_19().t5q_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_6(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2()), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[6].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_18() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
var CreditClass;
function Credit() {
  if (CreditClass === VOID) {
    class $ {
      constructor(amount, timestamp, lineItem, incident, projectCreditGroup, reason, readBy) {
        Companion_getInstance_19();
        var tmp;
        if (timestamp === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).d1m();
        } else {
          tmp = timestamp;
        }
        timestamp = tmp;
        lineItem = lineItem === VOID ? null : lineItem;
        incident = incident === VOID ? null : incident;
        projectCreditGroup = projectCreditGroup === VOID ? null : projectCreditGroup;
        reason = reason === VOID ? '' : reason;
        readBy = readBy === VOID ? emptySet() : readBy;
        this.a5r_1 = amount;
        this.b5r_1 = timestamp;
        this.c5r_1 = lineItem;
        this.d5r_1 = incident;
        this.e5r_1 = projectCreditGroup;
        this.f5r_1 = reason;
        this.g5r_1 = readBy;
      }
      b95() {
        return this.b5r_1;
      }
      t91() {
        return this.g5r_1;
      }
      a95() {
        return MonetaryValue__unaryMinus_impl_x5smq0(this.a5r_1);
      }
      g26() {
        var tmp0_safe_receiver = this.e5r_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = 'PC' + tmp0_safe_receiver;
        }
        return tmp;
      }
      f94() {
        return !(this.e5r_1 == null) ? 'Project Credit' : 'Credit';
      }
      y9v(amount, timestamp, lineItem, incident, projectCreditGroup, reason, readBy) {
        return new (Credit())(amount, timestamp, lineItem, incident, projectCreditGroup, reason, readBy);
      }
      i5r(amount, timestamp, lineItem, incident, projectCreditGroup, reason, readBy, $super) {
        amount = amount === VOID ? this.a5r_1 : amount;
        timestamp = timestamp === VOID ? this.b5r_1 : timestamp;
        lineItem = lineItem === VOID ? this.c5r_1 : lineItem;
        incident = incident === VOID ? this.d5r_1 : incident;
        projectCreditGroup = projectCreditGroup === VOID ? this.e5r_1 : projectCreditGroup;
        reason = reason === VOID ? this.f5r_1 : reason;
        readBy = readBy === VOID ? this.g5r_1 : readBy;
        return $super === VOID ? this.y9v(amount, timestamp, lineItem, incident, projectCreditGroup, reason, readBy) : $super.y9v.call(this, new (MonetaryValue())(amount), timestamp, lineItem, incident, projectCreditGroup, reason, readBy);
      }
      toString() {
        return 'Credit(amount=' + MonetaryValue__toString_impl_xslc77(this.a5r_1) + ', timestamp=' + this.b5r_1.toString() + ', lineItem=' + toString_0(this.c5r_1) + ', incident=' + toString_0(this.d5r_1) + ', projectCreditGroup=' + this.e5r_1 + ', reason=' + this.f5r_1 + ', readBy=' + toString(this.g5r_1) + ')';
      }
      hashCode() {
        var result = MonetaryValue__hashCode_impl_fhcsz2(this.a5r_1);
        result = imul(result, 31) + this.b5r_1.hashCode() | 0;
        result = imul(result, 31) + (this.c5r_1 == null ? 0 : this.c5r_1.hashCode()) | 0;
        result = imul(result, 31) + (this.d5r_1 == null ? 0 : this.d5r_1.hashCode()) | 0;
        result = imul(result, 31) + (this.e5r_1 == null ? 0 : this.e5r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f5r_1) | 0;
        result = imul(result, 31) + hashCode(this.g5r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Credit()))
          return false;
        if (!(this.a5r_1 === other.a5r_1))
          return false;
        if (!this.b5r_1.equals(other.b5r_1))
          return false;
        if (!equals(this.c5r_1, other.c5r_1))
          return false;
        if (!equals(this.d5r_1, other.d5r_1))
          return false;
        if (!(this.e5r_1 == other.e5r_1))
          return false;
        if (!(this.f5r_1 === other.f5r_1))
          return false;
        if (!equals(this.g5r_1, other.g5r_1))
          return false;
        return true;
      }
      static x9v(seen0, amount, timestamp, lineItem, incident, projectCreditGroup, reason, readBy, serializationConstructorMarker) {
        Companion_getInstance_19();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_18().v9v_1);
        }
        var $this = createThis(this);
        $this.a5r_1 = amount;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.b5r_1 = get_default(Companion_instance).d1m();
        } else
          $this.b5r_1 = timestamp;
        if (0 === (seen0 & 4))
          $this.c5r_1 = null;
        else
          $this.c5r_1 = lineItem;
        if (0 === (seen0 & 8))
          $this.d5r_1 = null;
        else
          $this.d5r_1 = incident;
        if (0 === (seen0 & 16))
          $this.e5r_1 = null;
        else
          $this.e5r_1 = projectCreditGroup;
        if (0 === (seen0 & 32))
          $this.f5r_1 = '';
        else
          $this.f5r_1 = reason;
        if (0 === (seen0 & 64))
          $this.g5r_1 = emptySet();
        else
          $this.g5r_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'Credit', VOID, VOID, [DrawTableItem()], VOID, VOID, {0: $serializer_getInstance_18});
    CreditClass = $;
  }
  return CreditClass;
}
function CrowPayAlert$Companion$$childSerializers$_anonymous__zabjtt() {
  return Companion_getInstance_37().m2a();
}
function CrowPayAlert$Companion$$childSerializers$_anonymous__zabjtt_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      constructor() {
        Companion_instance_16 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, CrowPayAlert$Companion$$childSerializers$_anonymous__zabjtt);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s5s_1 = [null, null, tmp_1, null, null, null, null, lazy(tmp_2, CrowPayAlert$Companion$$childSerializers$_anonymous__zabjtt_0)];
      }
      m2a() {
        return $serializer_getInstance_19();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_16;
function Companion_getInstance_20() {
  if (Companion_instance_16 === VOID)
    new (Companion_15())();
  return Companion_instance_16;
}
var $serializerClass_12;
function $serializer_12() {
  if ($serializerClass_12 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.CrowPayAlert', this, 8);
        tmp0_serialDesc.c1b('title', false);
        tmp0_serialDesc.c1b('body', false);
        tmp0_serialDesc.c1b('category', true);
        tmp0_serialDesc.c1b('isReminder', true);
        tmp0_serialDesc.c1b('read', true);
        tmp0_serialDesc.c1b('url', true);
        tmp0_serialDesc.c1b('email', true);
        tmp0_serialDesc.c1b('project', true);
        this.z9v_1 = tmp0_serialDesc;
      }
      a9w(encoder, value) {
        var tmp0_desc = this.z9v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_20().s5s_1;
        tmp1_output.a15(tmp0_desc, 0, value.z5s_1);
        tmp1_output.a15(tmp0_desc, 1, value.a5t_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !value.b5t_1.equals(AlertCategory_Info_getInstance())) {
          tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.b5t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.c5t_1 === false)) {
          tmp1_output.s14(tmp0_desc, 3, value.c5t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.d5t_1 === false)) {
          tmp1_output.s14(tmp0_desc, 4, value.d5t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.e5t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, StringSerializer_getInstance(), value.e5t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.f5t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, $serializer_getInstance_42(), value.f5t_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.g5t_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, tmp2_cached[7].f2(), value.g5t_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a9w(encoder, value instanceof CrowPayAlert() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z9v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.l13(tmp0_desc);
        var tmp13_cached = Companion_getInstance_20().s5s_1;
        if (tmp12_input.a14()) {
          tmp4_local0 = tmp12_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp12_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, tmp13_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.z13(tmp0_desc, 6, $serializer_getInstance_42(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp12_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.x13(tmp0_desc, 2, tmp13_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.z13(tmp0_desc, 6, $serializer_getInstance_42(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.z13(tmp0_desc, 7, tmp13_cached[7].f2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp12_input.m13(tmp0_desc);
        return CrowPayAlert().b9w(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      az() {
        return this.z9v_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_20().s5s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_42()), get_nullable(tmp0_cached[7].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_12 = $;
  }
  return $serializerClass_12;
}
var $serializer_instance_12;
function $serializer_getInstance_19() {
  if ($serializer_instance_12 === VOID)
    new ($serializer_12())();
  return $serializer_instance_12;
}
var CrowPayAlertClass;
function CrowPayAlert() {
  if (CrowPayAlertClass === VOID) {
    class $ {
      constructor(title, body, category, isReminder, read, url, email, project) {
        Companion_getInstance_20();
        category = category === VOID ? AlertCategory_Info_getInstance() : category;
        isReminder = isReminder === VOID ? false : isReminder;
        read = read === VOID ? false : read;
        url = url === VOID ? null : url;
        email = email === VOID ? null : email;
        project = project === VOID ? null : project;
        this.z5s_1 = title;
        this.a5t_1 = body;
        this.b5t_1 = category;
        this.c5t_1 = isReminder;
        this.d5t_1 = read;
        this.e5t_1 = url;
        this.f5t_1 = email;
        this.g5t_1 = project;
      }
      c9w(title, body, category, isReminder, read, url, email, project) {
        return new (CrowPayAlert())(title, body, category, isReminder, read, url, email, project);
      }
      i5t(title, body, category, isReminder, read, url, email, project, $super) {
        title = title === VOID ? this.z5s_1 : title;
        body = body === VOID ? this.a5t_1 : body;
        category = category === VOID ? this.b5t_1 : category;
        isReminder = isReminder === VOID ? this.c5t_1 : isReminder;
        read = read === VOID ? this.d5t_1 : read;
        url = url === VOID ? this.e5t_1 : url;
        email = email === VOID ? this.f5t_1 : email;
        project = project === VOID ? this.g5t_1 : project;
        return $super === VOID ? this.c9w(title, body, category, isReminder, read, url, email, project) : $super.c9w.call(this, title, body, category, isReminder, read, url, email, project);
      }
      toString() {
        return 'CrowPayAlert(title=' + this.z5s_1 + ', body=' + this.a5t_1 + ', category=' + toString(this.b5t_1) + ', isReminder=' + this.c5t_1 + ', read=' + this.d5t_1 + ', url=' + this.e5t_1 + ', email=' + toString_0(this.f5t_1) + ', project=' + toString_0(this.g5t_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.z5s_1);
        result = imul(result, 31) + getStringHashCode(this.a5t_1) | 0;
        result = imul(result, 31) + this.b5t_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.c5t_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.d5t_1) | 0;
        result = imul(result, 31) + (this.e5t_1 == null ? 0 : getStringHashCode(this.e5t_1)) | 0;
        result = imul(result, 31) + (this.f5t_1 == null ? 0 : this.f5t_1.hashCode()) | 0;
        result = imul(result, 31) + (this.g5t_1 == null ? 0 : this.g5t_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CrowPayAlert()))
          return false;
        if (!(this.z5s_1 === other.z5s_1))
          return false;
        if (!(this.a5t_1 === other.a5t_1))
          return false;
        if (!this.b5t_1.equals(other.b5t_1))
          return false;
        if (!(this.c5t_1 === other.c5t_1))
          return false;
        if (!(this.d5t_1 === other.d5t_1))
          return false;
        if (!(this.e5t_1 == other.e5t_1))
          return false;
        if (!equals(this.f5t_1, other.f5t_1))
          return false;
        if (!equals(this.g5t_1, other.g5t_1))
          return false;
        return true;
      }
      static b9w(seen0, title, body, category, isReminder, read, url, email, project, serializationConstructorMarker) {
        Companion_getInstance_20();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_19().z9v_1);
        }
        var $this = createThis(this);
        $this.z5s_1 = title;
        $this.a5t_1 = body;
        if (0 === (seen0 & 4))
          $this.b5t_1 = AlertCategory_Info_getInstance();
        else
          $this.b5t_1 = category;
        if (0 === (seen0 & 8))
          $this.c5t_1 = false;
        else
          $this.c5t_1 = isReminder;
        if (0 === (seen0 & 16))
          $this.d5t_1 = false;
        else
          $this.d5t_1 = read;
        if (0 === (seen0 & 32))
          $this.e5t_1 = null;
        else
          $this.e5t_1 = url;
        if (0 === (seen0 & 64))
          $this.f5t_1 = null;
        else
          $this.f5t_1 = email;
        if (0 === (seen0 & 128))
          $this.g5t_1 = null;
        else
          $this.g5t_1 = project;
        return $this;
      }
    }
    initMetadataForClass($, 'CrowPayAlert', VOID, VOID, [NotificationContent()], VOID, VOID, {0: $serializer_getInstance_19});
    CrowPayAlertClass = $;
  }
  return CrowPayAlertClass;
}
function IdAndFeedback$Companion$$childSerializers$_anonymous__za0f07() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      constructor() {
        Companion_instance_17 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g8s_1 = [lazy(tmp_0, IdAndFeedback$Companion$$childSerializers$_anonymous__za0f07), null];
      }
      m2a() {
        return $serializer_getInstance_20();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_17;
function Companion_getInstance_21() {
  if (Companion_instance_17 === VOID)
    new (Companion_16())();
  return Companion_instance_17;
}
var $serializerClass_13;
function $serializer_13() {
  if ($serializerClass_13 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.IdAndFeedback', this, 2);
        tmp0_serialDesc.c1b('_id', false);
        tmp0_serialDesc.c1b('feedback', false);
        this.d9w_1 = tmp0_serialDesc;
      }
      e9w(encoder, value) {
        var tmp0_desc = this.d9w_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_21().g8s_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.f9w_1);
        tmp1_output.a15(tmp0_desc, 1, value.g9w_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e9w(encoder, value instanceof IdAndFeedback() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d9w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_21().g8s_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return IdAndFeedback().h9w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.d9w_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_21().g8s_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_13 = $;
  }
  return $serializerClass_13;
}
var $serializer_instance_13;
function $serializer_getInstance_20() {
  if ($serializer_instance_13 === VOID)
    new ($serializer_13())();
  return $serializer_instance_13;
}
var IdAndFeedbackClass;
function IdAndFeedback() {
  if (IdAndFeedbackClass === VOID) {
    class $ {
      constructor(_id, feedback) {
        Companion_getInstance_21();
        this.f9w_1 = _id;
        this.g9w_1 = feedback;
      }
      h40() {
        return this.f9w_1;
      }
      toString() {
        return 'IdAndFeedback(_id=' + this.f9w_1.toString() + ', feedback=' + this.g9w_1 + ')';
      }
      hashCode() {
        var result = this.f9w_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.g9w_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IdAndFeedback()))
          return false;
        if (!this.f9w_1.equals(other.f9w_1))
          return false;
        if (!(this.g9w_1 === other.g9w_1))
          return false;
        return true;
      }
      static h9w(seen0, _id, feedback, serializationConstructorMarker) {
        Companion_getInstance_21();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_20().d9w_1);
        }
        var $this = createThis(this);
        $this.f9w_1 = _id;
        $this.g9w_1 = feedback;
        return $this;
      }
    }
    initMetadataForClass($, 'IdAndFeedback', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_20});
    IdAndFeedbackClass = $;
  }
  return IdAndFeedbackClass;
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_21();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_18;
function Companion_getInstance_22() {
  return Companion_instance_18;
}
var $serializerClass_14;
function $serializer_14() {
  if ($serializerClass_14 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.HashAndFeedback', this, 2);
        tmp0_serialDesc.c1b('hash', false);
        tmp0_serialDesc.c1b('feedback', false);
        this.i9w_1 = tmp0_serialDesc;
      }
      j9w(encoder, value) {
        var tmp0_desc = this.i9w_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.k9w_1);
        tmp1_output.a15(tmp0_desc, 1, value.l9w_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.j9w(encoder, value instanceof HashAndFeedback() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.i9w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return HashAndFeedback().m9w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.i9w_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_14 = $;
  }
  return $serializerClass_14;
}
var $serializer_instance_14;
function $serializer_getInstance_21() {
  if ($serializer_instance_14 === VOID)
    new ($serializer_14())();
  return $serializer_instance_14;
}
var HashAndFeedbackClass;
function HashAndFeedback() {
  if (HashAndFeedbackClass === VOID) {
    class $ {
      constructor(hash, feedback) {
        this.k9w_1 = hash;
        this.l9w_1 = feedback;
      }
      toString() {
        return 'HashAndFeedback(hash=' + this.k9w_1 + ', feedback=' + this.l9w_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.k9w_1);
        result = imul(result, 31) + getStringHashCode(this.l9w_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HashAndFeedback()))
          return false;
        if (!(this.k9w_1 === other.k9w_1))
          return false;
        if (!(this.l9w_1 === other.l9w_1))
          return false;
        return true;
      }
      static m9w(seen0, hash, feedback, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_21().i9w_1);
        }
        var $this = createThis(this);
        $this.k9w_1 = hash;
        $this.l9w_1 = feedback;
        return $this;
      }
    }
    initMetadataForClass($, 'HashAndFeedback', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
    HashAndFeedbackClass = $;
  }
  return HashAndFeedbackClass;
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_22();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_19;
function Companion_getInstance_23() {
  return Companion_instance_19;
}
var $serializerClass_15;
function $serializer_15() {
  if ($serializerClass_15 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.EmailAddressWithName', this, 2);
        tmp0_serialDesc.c1b('email', false);
        tmp0_serialDesc.c1b('name', false);
        this.n9w_1 = tmp0_serialDesc;
      }
      o9w(encoder, value) {
        var tmp0_desc = this.n9w_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.p9w_1));
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.q9w_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o9w(encoder, value instanceof EmailAddressWithName() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n9w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.c3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = EmailAddressSerializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (EmailAddress())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.c3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return EmailAddressWithName().r9w(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.n9w_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [EmailAddressSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_15 = $;
  }
  return $serializerClass_15;
}
var $serializer_instance_15;
function $serializer_getInstance_22() {
  if ($serializer_instance_15 === VOID)
    new ($serializer_15())();
  return $serializer_instance_15;
}
var EmailAddressWithNameClass;
function EmailAddressWithName() {
  if (EmailAddressWithNameClass === VOID) {
    class $ {
      constructor(email, name) {
        this.p9w_1 = email;
        this.q9w_1 = name;
      }
      toString() {
        return 'EmailAddressWithName(email=' + EmailAddress__toString_impl_artjh3(this.p9w_1) + ', name=' + this.q9w_1 + ')';
      }
      hashCode() {
        var result = EmailAddress__hashCode_impl_wizg9y(this.p9w_1);
        result = imul(result, 31) + (this.q9w_1 == null ? 0 : getStringHashCode(this.q9w_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmailAddressWithName()))
          return false;
        if (!(this.p9w_1 === other.p9w_1))
          return false;
        if (!(this.q9w_1 == other.q9w_1))
          return false;
        return true;
      }
      static r9w(seen0, email, name, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_22().n9w_1);
        }
        var $this = createThis(this);
        $this.p9w_1 = email;
        $this.q9w_1 = name;
        return $this;
      }
    }
    initMetadataForClass($, 'EmailAddressWithName', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
    EmailAddressWithNameClass = $;
  }
  return EmailAddressWithNameClass;
}
function AnonymousProjectInfo$Companion$$childSerializers$_anonymous__ahwe40() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function AnonymousProjectInfo$Companion$$childSerializers$_anonymous__ahwe40_0() {
  return new (ArrayListSerializer())($serializer_getInstance_1());
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      constructor() {
        Companion_instance_20 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, AnonymousProjectInfo$Companion$$childSerializers$_anonymous__ahwe40);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.q8s_1 = [null, null, null, tmp_1, lazy(tmp_2, AnonymousProjectInfo$Companion$$childSerializers$_anonymous__ahwe40_0)];
      }
      m2a() {
        return $serializer_getInstance_23();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_20;
function Companion_getInstance_24() {
  if (Companion_instance_20 === VOID)
    new (Companion_19())();
  return Companion_instance_20;
}
var $serializerClass_16;
function $serializer_16() {
  if ($serializerClass_16 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.AnonymousProjectInfo', this, 5);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.c1b('client', false);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.c1b('lineItems', false);
        tmp0_serialDesc.c1b('scopesViews', false);
        this.s9w_1 = tmp0_serialDesc;
      }
      t9w(encoder, value) {
        var tmp0_desc = this.s9w_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_24().q8s_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_2(), value.u9w_1);
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_3(), value.v9w_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance(), value.w9w_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.x9w_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.y9w_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t9w(encoder, value instanceof AnonymousProjectInfo() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s9w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_24().q8s_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.x13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.x13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return AnonymousProjectInfo().z9w(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.s9w_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_24().q8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_2(), $serializer_getInstance_3(), $serializer_getInstance(), tmp0_cached[3].f2(), tmp0_cached[4].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_16 = $;
  }
  return $serializerClass_16;
}
var $serializer_instance_16;
function $serializer_getInstance_23() {
  if ($serializer_instance_16 === VOID)
    new ($serializer_16())();
  return $serializer_instance_16;
}
var AnonymousProjectInfoClass;
function AnonymousProjectInfo() {
  if (AnonymousProjectInfoClass === VOID) {
    class $ {
      constructor(project, client, contractor, lineItems, scopesViews) {
        Companion_getInstance_24();
        this.u9w_1 = project;
        this.v9w_1 = client;
        this.w9w_1 = contractor;
        this.x9w_1 = lineItems;
        this.y9w_1 = scopesViews;
      }
      a9x(project, client, contractor, lineItems, scopesViews) {
        return new (AnonymousProjectInfo())(project, client, contractor, lineItems, scopesViews);
      }
      b9x(project, client, contractor, lineItems, scopesViews, $super) {
        project = project === VOID ? this.u9w_1 : project;
        client = client === VOID ? this.v9w_1 : client;
        contractor = contractor === VOID ? this.w9w_1 : contractor;
        lineItems = lineItems === VOID ? this.x9w_1 : lineItems;
        scopesViews = scopesViews === VOID ? this.y9w_1 : scopesViews;
        return $super === VOID ? this.a9x(project, client, contractor, lineItems, scopesViews) : $super.a9x.call(this, project, client, contractor, lineItems, scopesViews);
      }
      toString() {
        return 'AnonymousProjectInfo(project=' + this.u9w_1.toString() + ', client=' + this.v9w_1.toString() + ', contractor=' + this.w9w_1.toString() + ', lineItems=' + toString(this.x9w_1) + ', scopesViews=' + toString(this.y9w_1) + ')';
      }
      hashCode() {
        var result = this.u9w_1.hashCode();
        result = imul(result, 31) + this.v9w_1.hashCode() | 0;
        result = imul(result, 31) + this.w9w_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.x9w_1) | 0;
        result = imul(result, 31) + hashCode(this.y9w_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AnonymousProjectInfo()))
          return false;
        if (!this.u9w_1.equals(other.u9w_1))
          return false;
        if (!this.v9w_1.equals(other.v9w_1))
          return false;
        if (!this.w9w_1.equals(other.w9w_1))
          return false;
        if (!equals(this.x9w_1, other.x9w_1))
          return false;
        if (!equals(this.y9w_1, other.y9w_1))
          return false;
        return true;
      }
      static z9w(seen0, project, client, contractor, lineItems, scopesViews, serializationConstructorMarker) {
        Companion_getInstance_24();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance_23().s9w_1);
        }
        var $this = createThis(this);
        $this.u9w_1 = project;
        $this.v9w_1 = client;
        $this.w9w_1 = contractor;
        $this.x9w_1 = lineItems;
        $this.y9w_1 = scopesViews;
        return $this;
      }
    }
    initMetadataForClass($, 'AnonymousProjectInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
    AnonymousProjectInfoClass = $;
  }
  return AnonymousProjectInfoClass;
}
function FiledForArbitration$Companion$$childSerializers$_anonymous__utd2k() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (ArrayListSerializer())(ContextualSerializer().zy(tmp, null, tmp$ret$2));
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      constructor() {
        Companion_instance_21 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n60_1 = [null, lazy(tmp_0, FiledForArbitration$Companion$$childSerializers$_anonymous__utd2k)];
      }
      m2a() {
        return $serializer_getInstance_24();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_21;
function Companion_getInstance_25() {
  if (Companion_instance_21 === VOID)
    new (Companion_20())();
  return Companion_instance_21;
}
var $serializerClass_17;
function $serializer_17() {
  if ($serializerClass_17 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_17 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.FiledForArbitration', this, 2);
        tmp0_serialDesc.c1b('accessInfo', false);
        tmp0_serialDesc.c1b('evidence', false);
        this.c9x_1 = tmp0_serialDesc;
      }
      d9x(encoder, value) {
        var tmp0_desc = this.c9x_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_25().n60_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_30(), value.s60_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.t60_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d9x(encoder, value instanceof FiledForArbitration() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c9x_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_25().n60_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_30(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_30(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return FiledForArbitration().e9x(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.c9x_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_25().n60_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_30(), tmp0_cached[1].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_17 = $;
  }
  return $serializerClass_17;
}
var $serializer_instance_17;
function $serializer_getInstance_24() {
  if ($serializer_instance_17 === VOID)
    new ($serializer_17())();
  return $serializer_instance_17;
}
var FiledForArbitrationClass;
function FiledForArbitration() {
  if (FiledForArbitrationClass === VOID) {
    class $ {
      constructor(accessInfo, evidence) {
        Companion_getInstance_25();
        this.s60_1 = accessInfo;
        this.t60_1 = evidence;
      }
      f9x(accessInfo, evidence) {
        return new (FiledForArbitration())(accessInfo, evidence);
      }
      v60(accessInfo, evidence, $super) {
        accessInfo = accessInfo === VOID ? this.s60_1 : accessInfo;
        evidence = evidence === VOID ? this.t60_1 : evidence;
        return $super === VOID ? this.f9x(accessInfo, evidence) : $super.f9x.call(this, accessInfo, evidence);
      }
      toString() {
        return 'FiledForArbitration(accessInfo=' + this.s60_1.toString() + ', evidence=' + toString(this.t60_1) + ')';
      }
      hashCode() {
        var result = this.s60_1.hashCode();
        result = imul(result, 31) + hashCode(this.t60_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FiledForArbitration()))
          return false;
        if (!this.s60_1.equals(other.s60_1))
          return false;
        if (!equals(this.t60_1, other.t60_1))
          return false;
        return true;
      }
      static e9x(seen0, accessInfo, evidence, serializationConstructorMarker) {
        Companion_getInstance_25();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_24().c9x_1);
        }
        var $this = createThis(this);
        $this.s60_1 = accessInfo;
        $this.t60_1 = evidence;
        return $this;
      }
    }
    initMetadataForClass($, 'FiledForArbitration', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
    FiledForArbitrationClass = $;
  }
  return FiledForArbitrationClass;
}
function CompletionRequest$Companion$$childSerializers$_anonymous__lenot3() {
  return new (ArrayListSerializer())($serializer_getInstance_7());
}
var CompanionClass_21;
function Companion_21() {
  if (CompanionClass_21 === VOID) {
    class $ {
      constructor() {
        Companion_instance_22 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o5f_1 = [null, null, lazy(tmp_0, CompletionRequest$Companion$$childSerializers$_anonymous__lenot3), null, null];
      }
      m2a() {
        return $serializer_getInstance_25();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_21 = $;
  }
  return CompanionClass_21;
}
var Companion_instance_22;
function Companion_getInstance_26() {
  if (Companion_instance_22 === VOID)
    new (Companion_21())();
  return Companion_instance_22;
}
var $serializerClass_18;
function $serializer_18() {
  if ($serializerClass_18 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_18 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.CompletionRequest', this, 5);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.c1b('requestSummary', true);
        tmp0_serialDesc.c1b('files', true);
        tmp0_serialDesc.c1b('customer', true);
        tmp0_serialDesc.c1b('autoRelease', true);
        this.g9x_1 = tmp0_serialDesc;
      }
      h9x(encoder, value) {
        var tmp0_desc = this.g9x_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_26().o5f_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_30(), value.t5f_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.u5f_1 === '')) {
          tmp1_output.a15(tmp0_desc, 1, value.u5f_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !equals(value.v5f_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.v5f_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.w5f_1 == null)) {
          tmp1_output.d15(tmp0_desc, 3, $serializer_getInstance_30(), value.w5f_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.x5f_1 === true)) {
          tmp1_output.s14(tmp0_desc, 4, value.x5f_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.h9x(encoder, value instanceof CompletionRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g9x_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_26().o5f_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, $serializer_getInstance_30(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.z13(tmp0_desc, 3, $serializer_getInstance_30(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, $serializer_getInstance_30(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.z13(tmp0_desc, 3, $serializer_getInstance_30(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return CompletionRequest().i9x(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.g9x_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_26().o5f_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_30(), StringSerializer_getInstance(), tmp0_cached[2].f2(), get_nullable($serializer_getInstance_30()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_18 = $;
  }
  return $serializerClass_18;
}
var $serializer_instance_18;
function $serializer_getInstance_25() {
  if ($serializer_instance_18 === VOID)
    new ($serializer_18())();
  return $serializer_instance_18;
}
var CompletionRequestClass;
function CompletionRequest() {
  if (CompletionRequestClass === VOID) {
    class $ {
      constructor(contractor, requestSummary, files, customer, autoRelease) {
        Companion_getInstance_26();
        requestSummary = requestSummary === VOID ? '' : requestSummary;
        files = files === VOID ? emptyList() : files;
        customer = customer === VOID ? null : customer;
        autoRelease = autoRelease === VOID ? true : autoRelease;
        this.t5f_1 = contractor;
        this.u5f_1 = requestSummary;
        this.v5f_1 = files;
        this.w5f_1 = customer;
        this.x5f_1 = autoRelease;
      }
      j9x(contractor, requestSummary, files, customer, autoRelease) {
        return new (CompletionRequest())(contractor, requestSummary, files, customer, autoRelease);
      }
      z5f(contractor, requestSummary, files, customer, autoRelease, $super) {
        contractor = contractor === VOID ? this.t5f_1 : contractor;
        requestSummary = requestSummary === VOID ? this.u5f_1 : requestSummary;
        files = files === VOID ? this.v5f_1 : files;
        customer = customer === VOID ? this.w5f_1 : customer;
        autoRelease = autoRelease === VOID ? this.x5f_1 : autoRelease;
        return $super === VOID ? this.j9x(contractor, requestSummary, files, customer, autoRelease) : $super.j9x.call(this, contractor, requestSummary, files, customer, autoRelease);
      }
      toString() {
        return 'CompletionRequest(contractor=' + this.t5f_1.toString() + ', requestSummary=' + this.u5f_1 + ', files=' + toString(this.v5f_1) + ', customer=' + toString_0(this.w5f_1) + ', autoRelease=' + this.x5f_1 + ')';
      }
      hashCode() {
        var result = this.t5f_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.u5f_1) | 0;
        result = imul(result, 31) + hashCode(this.v5f_1) | 0;
        result = imul(result, 31) + (this.w5f_1 == null ? 0 : this.w5f_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.x5f_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CompletionRequest()))
          return false;
        if (!this.t5f_1.equals(other.t5f_1))
          return false;
        if (!(this.u5f_1 === other.u5f_1))
          return false;
        if (!equals(this.v5f_1, other.v5f_1))
          return false;
        if (!equals(this.w5f_1, other.w5f_1))
          return false;
        if (!(this.x5f_1 === other.x5f_1))
          return false;
        return true;
      }
      static i9x(seen0, contractor, requestSummary, files, customer, autoRelease, serializationConstructorMarker) {
        Companion_getInstance_26();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_25().g9x_1);
        }
        var $this = createThis(this);
        $this.t5f_1 = contractor;
        if (0 === (seen0 & 2))
          $this.u5f_1 = '';
        else
          $this.u5f_1 = requestSummary;
        if (0 === (seen0 & 4))
          $this.v5f_1 = emptyList();
        else
          $this.v5f_1 = files;
        if (0 === (seen0 & 8))
          $this.w5f_1 = null;
        else
          $this.w5f_1 = customer;
        if (0 === (seen0 & 16))
          $this.x5f_1 = true;
        else
          $this.x5f_1 = autoRelease;
        return $this;
      }
    }
    initMetadataForClass($, 'CompletionRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_25});
    CompletionRequestClass = $;
  }
  return CompletionRequestClass;
}
function AddUserToMembership$Companion$$childSerializers$_anonymous__yr6s1f() {
  return Companion_getInstance_1().m2a();
}
var CompanionClass_22;
function Companion_22() {
  if (CompanionClass_22 === VOID) {
    class $ {
      constructor() {
        Companion_instance_23 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.x8s_1 = [null, lazy(tmp_0, AddUserToMembership$Companion$$childSerializers$_anonymous__yr6s1f)];
      }
      m2a() {
        return $serializer_getInstance_26();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_22 = $;
  }
  return CompanionClass_22;
}
var Companion_instance_23;
function Companion_getInstance_27() {
  if (Companion_instance_23 === VOID)
    new (Companion_22())();
  return Companion_instance_23;
}
var $serializerClass_19;
function $serializer_19() {
  if ($serializerClass_19 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_19 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.AddUserToMembership', this, 2);
        tmp0_serialDesc.c1b('userEmail', false);
        tmp0_serialDesc.c1b('role', false);
        this.k9x_1 = tmp0_serialDesc;
      }
      l9x(encoder, value) {
        var tmp0_desc = this.k9x_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_27().x8s_1;
        tmp1_output.c15(tmp0_desc, 0, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.m9x_1));
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.n9x_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l9x(encoder, value instanceof AddUserToMembership() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k9x_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_27().x8s_1;
        if (tmp6_input.a14()) {
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.c3n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = EmailAddressSerializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (EmailAddress())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.c3n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return AddUserToMembership().o9x(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.k9x_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_27().x8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [EmailAddressSerializer_getInstance(), tmp0_cached[1].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_19 = $;
  }
  return $serializerClass_19;
}
var $serializer_instance_19;
function $serializer_getInstance_26() {
  if ($serializer_instance_19 === VOID)
    new ($serializer_19())();
  return $serializer_instance_19;
}
var AddUserToMembershipClass;
function AddUserToMembership() {
  if (AddUserToMembershipClass === VOID) {
    class $ {
      constructor(userEmail, role) {
        Companion_getInstance_27();
        this.m9x_1 = userEmail;
        this.n9x_1 = role;
      }
      toString() {
        return 'AddUserToMembership(userEmail=' + EmailAddress__toString_impl_artjh3(this.m9x_1) + ', role=' + this.n9x_1.toString() + ')';
      }
      hashCode() {
        var result = EmailAddress__hashCode_impl_wizg9y(this.m9x_1);
        result = imul(result, 31) + this.n9x_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AddUserToMembership()))
          return false;
        if (!(this.m9x_1 === other.m9x_1))
          return false;
        if (!this.n9x_1.equals(other.n9x_1))
          return false;
        return true;
      }
      static o9x(seen0, userEmail, role, serializationConstructorMarker) {
        Companion_getInstance_27();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_26().k9x_1);
        }
        var $this = createThis(this);
        $this.m9x_1 = userEmail;
        $this.n9x_1 = role;
        return $this;
      }
    }
    initMetadataForClass($, 'AddUserToMembership', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
    AddUserToMembershipClass = $;
  }
  return AddUserToMembershipClass;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.s8s_1.f2();
}
function LoginEmailRequest$Flavor$Companion$_anonymous__w44oon() {
  return createSimpleEnumSerializer('com.crowpay.LoginEmailRequest.Flavor', values_2());
}
var Flavor_HomeownerRegistration_instance;
var Flavor_ContractorRegistration_instance;
var Flavor_Generic_instance;
function values_2() {
  return [Flavor_HomeownerRegistration_getInstance(), Flavor_ContractorRegistration_getInstance(), Flavor_Generic_getInstance()];
}
var CompanionClass_23;
function Companion_23() {
  if (CompanionClass_23 === VOID) {
    class $ {
      constructor() {
        Companion_instance_24 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.s8s_1 = lazy(tmp_0, LoginEmailRequest$Flavor$Companion$_anonymous__w44oon);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_2(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_23 = $;
  }
  return CompanionClass_23;
}
var Companion_instance_24;
function Companion_getInstance_28() {
  Flavor_initEntries();
  if (Companion_instance_24 === VOID)
    new (Companion_23())();
  return Companion_instance_24;
}
var Flavor_entriesInitialized;
function Flavor_initEntries() {
  if (Flavor_entriesInitialized)
    return Unit_instance;
  Flavor_entriesInitialized = true;
  Flavor_HomeownerRegistration_instance = Flavor().r9x('HomeownerRegistration', 0);
  Flavor_ContractorRegistration_instance = Flavor().r9x('ContractorRegistration', 1);
  Flavor_Generic_instance = Flavor().r9x('Generic', 2);
  Companion_getInstance_28();
}
function LoginEmailRequest$Companion$$childSerializers$_anonymous__97p4i6() {
  return Companion_getInstance_28().m2a();
}
var FlavorClass;
function Flavor() {
  if (FlavorClass === VOID) {
    class $ extends Enum() {
      static r9x(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'Flavor', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_28});
    FlavorClass = $;
  }
  return FlavorClass;
}
var CompanionClass_24;
function Companion_24() {
  if (CompanionClass_24 === VOID) {
    class $ {
      constructor() {
        Companion_instance_25 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.r8s_1 = [null, null, null, lazy(tmp_0, LoginEmailRequest$Companion$$childSerializers$_anonymous__97p4i6)];
      }
      m2a() {
        return $serializer_getInstance_27();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_24 = $;
  }
  return CompanionClass_24;
}
var Companion_instance_25;
function Companion_getInstance_29() {
  if (Companion_instance_25 === VOID)
    new (Companion_24())();
  return Companion_instance_25;
}
var $serializerClass_20;
function $serializer_20() {
  if ($serializerClass_20 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_20 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LoginEmailRequest', this, 4);
        tmp0_serialDesc.c1b('firstName', false);
        tmp0_serialDesc.c1b('lastName', false);
        tmp0_serialDesc.c1b('email', false);
        tmp0_serialDesc.c1b('flavor', false);
        this.s9x_1 = tmp0_serialDesc;
      }
      t9x(encoder, value) {
        var tmp0_desc = this.s9x_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_29().r8s_1;
        tmp1_output.a15(tmp0_desc, 0, value.u9x_1);
        tmp1_output.a15(tmp0_desc, 1, value.v9x_1);
        tmp1_output.a15(tmp0_desc, 2, value.w9x_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.x9x_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t9x(encoder, value instanceof LoginEmailRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s9x_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_29().r8s_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return LoginEmailRequest().y9x(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.s9x_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_29().r8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_20 = $;
  }
  return $serializerClass_20;
}
var $serializer_instance_20;
function $serializer_getInstance_27() {
  if ($serializer_instance_20 === VOID)
    new ($serializer_20())();
  return $serializer_instance_20;
}
function Flavor_HomeownerRegistration_getInstance() {
  Flavor_initEntries();
  return Flavor_HomeownerRegistration_instance;
}
function Flavor_ContractorRegistration_getInstance() {
  Flavor_initEntries();
  return Flavor_ContractorRegistration_instance;
}
function Flavor_Generic_getInstance() {
  Flavor_initEntries();
  return Flavor_Generic_instance;
}
var LoginEmailRequestClass;
function LoginEmailRequest() {
  if (LoginEmailRequestClass === VOID) {
    class $ {
      static z9x(firstName, lastName, email, flavor) {
        Companion_getInstance_29();
        var $this = createThis(this);
        $this.u9x_1 = firstName;
        $this.v9x_1 = lastName;
        $this.w9x_1 = email;
        $this.x9x_1 = flavor;
        return $this;
      }
      static a9y(user, flavor) {
        Companion_getInstance_29();
        return this.z9x(user.j88_1, user.k88_1, _EmailAddress___get_raw__impl__6ose2(user.g88_1), flavor);
      }
      toString() {
        return 'LoginEmailRequest(firstName=' + this.u9x_1 + ', lastName=' + this.v9x_1 + ', email=' + this.w9x_1 + ', flavor=' + this.x9x_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.u9x_1);
        result = imul(result, 31) + getStringHashCode(this.v9x_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w9x_1) | 0;
        result = imul(result, 31) + this.x9x_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LoginEmailRequest()))
          return false;
        if (!(this.u9x_1 === other.u9x_1))
          return false;
        if (!(this.v9x_1 === other.v9x_1))
          return false;
        if (!(this.w9x_1 === other.w9x_1))
          return false;
        if (!this.x9x_1.equals(other.x9x_1))
          return false;
        return true;
      }
      static y9x(seen0, firstName, lastName, email, flavor, serializationConstructorMarker) {
        Companion_getInstance_29();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_27().s9x_1);
        }
        var $this = createThis(this);
        $this.u9x_1 = firstName;
        $this.v9x_1 = lastName;
        $this.w9x_1 = email;
        $this.x9x_1 = flavor;
        return $this;
      }
    }
    initMetadataForClass($, 'LoginEmailRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_27});
    LoginEmailRequestClass = $;
  }
  return LoginEmailRequestClass;
}
var CompanionClass_25;
function Companion_25() {
  if (CompanionClass_25 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_28();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_25 = $;
  }
  return CompanionClass_25;
}
var Companion_instance_26;
function Companion_getInstance_30() {
  return Companion_instance_26;
}
var $serializerClass_21;
function $serializer_21() {
  if ($serializerClass_21 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_21 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.RegisterUser', this, 2);
        tmp0_serialDesc.c1b('user', false);
        tmp0_serialDesc.c1b('proof', false);
        this.b9y_1 = tmp0_serialDesc;
      }
      c9y(encoder, value) {
        var tmp0_desc = this.b9y_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_4(), value.d9y_1);
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_5(), value.e9y_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.c9y(encoder, value instanceof RegisterUser() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.b9y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, $serializer_getInstance_5(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return RegisterUser().f9y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.b9y_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_4(), $serializer_getInstance_5()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_21 = $;
  }
  return $serializerClass_21;
}
var $serializer_instance_21;
function $serializer_getInstance_28() {
  if ($serializer_instance_21 === VOID)
    new ($serializer_21())();
  return $serializer_instance_21;
}
var RegisterUserClass;
function RegisterUser() {
  if (RegisterUserClass === VOID) {
    class $ {
      constructor(user, proof) {
        this.d9y_1 = user;
        this.e9y_1 = proof;
      }
      toString() {
        return 'RegisterUser(user=' + this.d9y_1.toString() + ', proof=' + this.e9y_1.toString() + ')';
      }
      hashCode() {
        var result = this.d9y_1.hashCode();
        result = imul(result, 31) + this.e9y_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RegisterUser()))
          return false;
        if (!this.d9y_1.equals(other.d9y_1))
          return false;
        if (!this.e9y_1.equals(other.e9y_1))
          return false;
        return true;
      }
      static f9y(seen0, user, proof, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_28().b9y_1);
        }
        var $this = createThis(this);
        $this.d9y_1 = user;
        $this.e9y_1 = proof;
        return $this;
      }
    }
    initMetadataForClass($, 'RegisterUser', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_28});
    RegisterUserClass = $;
  }
  return RegisterUserClass;
}
function AccessAndFeedback$Companion$$childSerializers$_anonymous__p3rmcy() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_26;
function Companion_26() {
  if (CompanionClass_26 === VOID) {
    class $ {
      constructor() {
        Companion_instance_27 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.m53_1 = [null, null, lazy(tmp_0, AccessAndFeedback$Companion$$childSerializers$_anonymous__p3rmcy)];
      }
      m2a() {
        return $serializer_getInstance_29();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_26 = $;
  }
  return CompanionClass_26;
}
var Companion_instance_27;
function Companion_getInstance_31() {
  if (Companion_instance_27 === VOID)
    new (Companion_26())();
  return Companion_instance_27;
}
var $serializerClass_22;
function $serializer_22() {
  if ($serializerClass_22 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_22 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.AccessAndFeedback', this, 3);
        tmp0_serialDesc.c1b('access', false);
        tmp0_serialDesc.c1b('feedback', false);
        tmp0_serialDesc.c1b('readBy', true);
        this.g9y_1 = tmp0_serialDesc;
      }
      h9y(encoder, value) {
        var tmp0_desc = this.g9y_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_31().m53_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_30(), value.r53_1);
        tmp1_output.a15(tmp0_desc, 1, value.s53_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !equals(value.t53_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.t53_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.h9y(encoder, value instanceof AccessAndFeedback() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g9y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_31().m53_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, $serializer_getInstance_30(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, $serializer_getInstance_30(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return AccessAndFeedback().i9y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.g9y_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_31().m53_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_30(), StringSerializer_getInstance(), tmp0_cached[2].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_22 = $;
  }
  return $serializerClass_22;
}
var $serializer_instance_22;
function $serializer_getInstance_29() {
  if ($serializer_instance_22 === VOID)
    new ($serializer_22())();
  return $serializer_instance_22;
}
var AccessAndFeedbackClass;
function AccessAndFeedback() {
  if (AccessAndFeedbackClass === VOID) {
    class $ {
      constructor(access, feedback, readBy) {
        Companion_getInstance_31();
        readBy = readBy === VOID ? emptySet() : readBy;
        this.r53_1 = access;
        this.s53_1 = feedback;
        this.t53_1 = readBy;
      }
      t91() {
        return this.t53_1;
      }
      b95() {
        return this.r53_1.q54_1;
      }
      j9y(access, feedback, readBy) {
        return new (AccessAndFeedback())(access, feedback, readBy);
      }
      v53(access, feedback, readBy, $super) {
        access = access === VOID ? this.r53_1 : access;
        feedback = feedback === VOID ? this.s53_1 : feedback;
        readBy = readBy === VOID ? this.t53_1 : readBy;
        return $super === VOID ? this.j9y(access, feedback, readBy) : $super.j9y.call(this, access, feedback, readBy);
      }
      toString() {
        return 'AccessAndFeedback(access=' + this.r53_1.toString() + ', feedback=' + this.s53_1 + ', readBy=' + toString(this.t53_1) + ')';
      }
      hashCode() {
        var result = this.r53_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.s53_1) | 0;
        result = imul(result, 31) + hashCode(this.t53_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AccessAndFeedback()))
          return false;
        if (!this.r53_1.equals(other.r53_1))
          return false;
        if (!(this.s53_1 === other.s53_1))
          return false;
        if (!equals(this.t53_1, other.t53_1))
          return false;
        return true;
      }
      static i9y(seen0, access, feedback, readBy, serializationConstructorMarker) {
        Companion_getInstance_31();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_29().g9y_1);
        }
        var $this = createThis(this);
        $this.r53_1 = access;
        $this.s53_1 = feedback;
        if (0 === (seen0 & 4))
          $this.t53_1 = emptySet();
        else
          $this.t53_1 = readBy;
        return $this;
      }
    }
    initMetadataForClass($, 'AccessAndFeedback', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
    AccessAndFeedbackClass = $;
  }
  return AccessAndFeedbackClass;
}
function AccessInfo$Companion$$childSerializers$_anonymous__nakt8o() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function AccessInfo$Companion$$childSerializers$_anonymous__nakt8o_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function AccessInfo$Companion$$childSerializers$_anonymous__nakt8o_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_27;
function Companion_27() {
  if (CompanionClass_27 === VOID) {
    class $ {
      constructor() {
        Companion_instance_28 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, AccessInfo$Companion$$childSerializers$_anonymous__nakt8o);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, AccessInfo$Companion$$childSerializers$_anonymous__nakt8o_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g54_1 = [tmp_1, null, tmp_3, null, lazy(tmp_4, AccessInfo$Companion$$childSerializers$_anonymous__nakt8o_1)];
        this.h54_1 = new (AccessInfo())(SharedUtils_getInstance().k9s_1, '', null, '', Companion_getInstance().e1m_1);
      }
      m2a() {
        return $serializer_getInstance_30();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_27 = $;
  }
  return CompanionClass_27;
}
var Companion_instance_28;
function Companion_getInstance_32() {
  if (Companion_instance_28 === VOID)
    new (Companion_27())();
  return Companion_instance_28;
}
var $serializerClass_23;
function $serializer_23() {
  if ($serializerClass_23 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_23 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.AccessInfo', this, 5);
        tmp0_serialDesc.c1b('user', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(User())));
        tmp0_serialDesc.c1b('ip', false);
        tmp0_serialDesc.c1b('sessionId', true);
        tmp0_serialDesc.c1b('userAgent', false);
        tmp0_serialDesc.c1b('timestamp', false);
        this.k9y_1 = tmp0_serialDesc;
      }
      l9y(encoder, value) {
        var tmp0_desc = this.k9y_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_32().g54_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.m54_1);
        tmp1_output.a15(tmp0_desc, 1, value.n54_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.o54_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.o54_1);
        }
        tmp1_output.a15(tmp0_desc, 3, value.p54_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.q54_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l9y(encoder, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k9y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_32().g54_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.z13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.x13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.z13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.x13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return AccessInfo().m9y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.k9y_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_32().g54_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), get_nullable(tmp0_cached[2].f2()), StringSerializer_getInstance(), tmp0_cached[4].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_23 = $;
  }
  return $serializerClass_23;
}
var $serializer_instance_23;
function $serializer_getInstance_30() {
  if ($serializer_instance_23 === VOID)
    new ($serializer_23())();
  return $serializer_instance_23;
}
var AccessInfoClass;
function AccessInfo() {
  if (AccessInfoClass === VOID) {
    class $ {
      constructor(user, ip, sessionId, userAgent, timestamp) {
        Companion_getInstance_32();
        sessionId = sessionId === VOID ? null : sessionId;
        this.m54_1 = user;
        this.n54_1 = ip;
        this.o54_1 = sessionId;
        this.p54_1 = userAgent;
        this.q54_1 = timestamp;
      }
      n9y(user, ip, sessionId, userAgent, timestamp) {
        return new (AccessInfo())(user, ip, sessionId, userAgent, timestamp);
      }
      s54(user, ip, sessionId, userAgent, timestamp, $super) {
        user = user === VOID ? this.m54_1 : user;
        ip = ip === VOID ? this.n54_1 : ip;
        sessionId = sessionId === VOID ? this.o54_1 : sessionId;
        userAgent = userAgent === VOID ? this.p54_1 : userAgent;
        timestamp = timestamp === VOID ? this.q54_1 : timestamp;
        return $super === VOID ? this.n9y(user, ip, sessionId, userAgent, timestamp) : $super.n9y.call(this, user, ip, sessionId, userAgent, timestamp);
      }
      toString() {
        return 'AccessInfo(user=' + this.m54_1.toString() + ', ip=' + this.n54_1 + ', sessionId=' + toString_0(this.o54_1) + ', userAgent=' + this.p54_1 + ', timestamp=' + this.q54_1.toString() + ')';
      }
      hashCode() {
        var result = this.m54_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.n54_1) | 0;
        result = imul(result, 31) + (this.o54_1 == null ? 0 : this.o54_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.p54_1) | 0;
        result = imul(result, 31) + this.q54_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AccessInfo()))
          return false;
        if (!this.m54_1.equals(other.m54_1))
          return false;
        if (!(this.n54_1 === other.n54_1))
          return false;
        if (!equals(this.o54_1, other.o54_1))
          return false;
        if (!(this.p54_1 === other.p54_1))
          return false;
        if (!this.q54_1.equals(other.q54_1))
          return false;
        return true;
      }
      static m9y(seen0, user, ip, sessionId, userAgent, timestamp, serializationConstructorMarker) {
        Companion_getInstance_32();
        if (!(27 === (27 & seen0))) {
          throwMissingFieldException(seen0, 27, $serializer_getInstance_30().k9y_1);
        }
        var $this = createThis(this);
        $this.m54_1 = user;
        $this.n54_1 = ip;
        if (0 === (seen0 & 4))
          $this.o54_1 = null;
        else
          $this.o54_1 = sessionId;
        $this.p54_1 = userAgent;
        $this.q54_1 = timestamp;
        return $this;
      }
    }
    initMetadataForClass($, 'AccessInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
    AccessInfoClass = $;
  }
  return AccessInfoClass;
}
var LineItemInterfaceClass;
function LineItemInterface() {
  if (LineItemInterfaceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'LineItemInterface');
    LineItemInterfaceClass = $;
  }
  return LineItemInterfaceClass;
}
function ChangeRequestInfo$Companion$$childSerializers$_anonymous__kywy1p() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_28;
function Companion_28() {
  if (CompanionClass_28 === VOID) {
    class $ {
      constructor() {
        Companion_instance_29 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u5a_1 = [lazy(tmp_0, ChangeRequestInfo$Companion$$childSerializers$_anonymous__kywy1p), null];
      }
      m2a() {
        return $serializer_getInstance_31();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_28 = $;
  }
  return CompanionClass_28;
}
var Companion_instance_29;
function Companion_getInstance_33() {
  if (Companion_instance_29 === VOID)
    new (Companion_28())();
  return Companion_instance_29;
}
var $serializerClass_24;
function $serializer_24() {
  if ($serializerClass_24 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_24 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ChangeRequestInfo', this, 2);
        tmp0_serialDesc.c1b('id', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(ChangeRequest())));
        tmp0_serialDesc.c1b('itemNumber', false);
        this.o9y_1 = tmp0_serialDesc;
      }
      p9y(encoder, value) {
        var tmp0_desc = this.o9y_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_33().u5a_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.z5a_1);
        tmp1_output.a15(tmp0_desc, 1, value.a5b_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.p9y(encoder, value instanceof ChangeRequestInfo() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.o9y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_33().u5a_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ChangeRequestInfo().q9y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.o9y_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_33().u5a_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_24 = $;
  }
  return $serializerClass_24;
}
var $serializer_instance_24;
function $serializer_getInstance_31() {
  if ($serializer_instance_24 === VOID)
    new ($serializer_24())();
  return $serializer_instance_24;
}
var ChangeRequestInfoClass;
function ChangeRequestInfo() {
  if (ChangeRequestInfoClass === VOID) {
    class $ {
      constructor(id, itemNumber) {
        Companion_getInstance_33();
        this.z5a_1 = id;
        this.a5b_1 = itemNumber;
      }
      r9y(id, itemNumber) {
        return new (ChangeRequestInfo())(id, itemNumber);
      }
      c5b(id, itemNumber, $super) {
        id = id === VOID ? this.z5a_1 : id;
        itemNumber = itemNumber === VOID ? this.a5b_1 : itemNumber;
        return $super === VOID ? this.r9y(id, itemNumber) : $super.r9y.call(this, id, itemNumber);
      }
      toString() {
        return 'ChangeRequestInfo(id=' + this.z5a_1.toString() + ', itemNumber=' + this.a5b_1 + ')';
      }
      hashCode() {
        var result = this.z5a_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.a5b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChangeRequestInfo()))
          return false;
        if (!this.z5a_1.equals(other.z5a_1))
          return false;
        if (!(this.a5b_1 === other.a5b_1))
          return false;
        return true;
      }
      static q9y(seen0, id, itemNumber, serializationConstructorMarker) {
        Companion_getInstance_33();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_31().o9y_1);
        }
        var $this = createThis(this);
        $this.z5a_1 = id;
        $this.a5b_1 = itemNumber;
        return $this;
      }
    }
    initMetadataForClass($, 'ChangeRequestInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_31});
    ChangeRequestInfoClass = $;
  }
  return ChangeRequestInfoClass;
}
var CompanionClass_29;
function Companion_29() {
  if (CompanionClass_29 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_32();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_29 = $;
  }
  return CompanionClass_29;
}
var Companion_instance_30;
function Companion_getInstance_34() {
  return Companion_instance_30;
}
var $serializerClass_25;
function $serializer_25() {
  if ($serializerClass_25 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_25 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Issue', this, 2);
        tmp0_serialDesc.c1b('raised', false);
        tmp0_serialDesc.c1b('resolved', true);
        this.s9y_1 = tmp0_serialDesc;
      }
      t9y(encoder, value) {
        var tmp0_desc = this.s9y_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_30(), value.i6a_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.j6a_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, $serializer_getInstance_30(), value.j6a_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t9y(encoder, value instanceof Issue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s9y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_30(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, $serializer_getInstance_30(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_30(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, $serializer_getInstance_30(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return Issue().u9y(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.s9y_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_30(), get_nullable($serializer_getInstance_30())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_25 = $;
  }
  return $serializerClass_25;
}
var $serializer_instance_25;
function $serializer_getInstance_32() {
  if ($serializer_instance_25 === VOID)
    new ($serializer_25())();
  return $serializer_instance_25;
}
var IssueClass;
function Issue() {
  if (IssueClass === VOID) {
    class $ {
      constructor(raised, resolved) {
        resolved = resolved === VOID ? null : resolved;
        this.i6a_1 = raised;
        this.j6a_1 = resolved;
      }
      v9y(raised, resolved) {
        return new (Issue())(raised, resolved);
      }
      l6a(raised, resolved, $super) {
        raised = raised === VOID ? this.i6a_1 : raised;
        resolved = resolved === VOID ? this.j6a_1 : resolved;
        return $super === VOID ? this.v9y(raised, resolved) : $super.v9y.call(this, raised, resolved);
      }
      toString() {
        return 'Issue(raised=' + this.i6a_1.toString() + ', resolved=' + toString_0(this.j6a_1) + ')';
      }
      hashCode() {
        var result = this.i6a_1.hashCode();
        result = imul(result, 31) + (this.j6a_1 == null ? 0 : this.j6a_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Issue()))
          return false;
        if (!this.i6a_1.equals(other.i6a_1))
          return false;
        if (!equals(this.j6a_1, other.j6a_1))
          return false;
        return true;
      }
      static u9y(seen0, raised, resolved, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_32().s9y_1);
        }
        var $this = createThis(this);
        $this.i6a_1 = raised;
        if (0 === (seen0 & 2))
          $this.j6a_1 = null;
        else
          $this.j6a_1 = resolved;
        return $this;
      }
    }
    initMetadataForClass($, 'Issue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
    IssueClass = $;
  }
  return IssueClass;
}
function Address$Companion$$childSerializers$_anonymous__5stgga() {
  return Companion_getInstance_2().m2a();
}
var CompanionClass_30;
function Companion_30() {
  if (CompanionClass_30 === VOID) {
    class $ {
      constructor() {
        Companion_instance_31 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.k55_1 = [null, null, null, lazy(tmp_0, Address$Companion$$childSerializers$_anonymous__5stgga), null];
      }
      m2a() {
        return $serializer_getInstance_33();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_30 = $;
  }
  return CompanionClass_30;
}
var Companion_instance_31;
function Companion_getInstance_35() {
  if (Companion_instance_31 === VOID)
    new (Companion_30())();
  return Companion_instance_31;
}
var $serializerClass_26;
function $serializer_26() {
  if ($serializerClass_26 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_26 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Address', this, 5);
        tmp0_serialDesc.c1b('line1', true);
        tmp0_serialDesc.c1b('line2', true);
        tmp0_serialDesc.c1b('city', true);
        tmp0_serialDesc.c1b('state', true);
        tmp0_serialDesc.c1b('zipcode', true);
        this.w9y_1 = tmp0_serialDesc;
      }
      x9y(encoder, value) {
        var tmp0_desc = this.w9y_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_35().k55_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.r55_1 === '')) {
          tmp1_output.a15(tmp0_desc, 0, value.r55_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.s55_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.s55_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.t55_1 === '')) {
          tmp1_output.a15(tmp0_desc, 2, value.t55_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !value.u55_1.equals(State_Utah_getInstance())) {
          tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.u55_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.v55_1 === '')) {
          tmp1_output.a15(tmp0_desc, 4, value.v55_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x9y(encoder, value instanceof Address() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w9y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_35().k55_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return Address().y9y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.w9y_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_35().k55_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[3].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_26 = $;
  }
  return $serializerClass_26;
}
var $serializer_instance_26;
function $serializer_getInstance_33() {
  if ($serializer_instance_26 === VOID)
    new ($serializer_26())();
  return $serializer_instance_26;
}
var AddressClass;
function Address() {
  if (AddressClass === VOID) {
    class $ {
      constructor(line1, line2, city, state, zipcode) {
        Companion_getInstance_35();
        line1 = line1 === VOID ? '' : line1;
        line2 = line2 === VOID ? null : line2;
        city = city === VOID ? '' : city;
        state = state === VOID ? State_Utah_getInstance() : state;
        zipcode = zipcode === VOID ? '' : zipcode;
        this.r55_1 = line1;
        this.s55_1 = line2;
        this.t55_1 = city;
        this.u55_1 = state;
        this.v55_1 = zipcode;
      }
      toString() {
        var tmp0_safe_receiver = this.s55_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = ' ' + tmp0_safe_receiver;
        }
        var tmp1_elvis_lhs = tmp;
        return this.r55_1 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + ', ' + this.t55_1 + ', ' + this.u55_1.f9b_1 + ' ' + this.v55_1;
      }
      z9y(line1, line2, city, state, zipcode) {
        return new (Address())(line1, line2, city, state, zipcode);
      }
      x55(line1, line2, city, state, zipcode, $super) {
        line1 = line1 === VOID ? this.r55_1 : line1;
        line2 = line2 === VOID ? this.s55_1 : line2;
        city = city === VOID ? this.t55_1 : city;
        state = state === VOID ? this.u55_1 : state;
        zipcode = zipcode === VOID ? this.v55_1 : zipcode;
        return $super === VOID ? this.z9y(line1, line2, city, state, zipcode) : $super.z9y.call(this, line1, line2, city, state, zipcode);
      }
      hashCode() {
        var result = getStringHashCode(this.r55_1);
        result = imul(result, 31) + (this.s55_1 == null ? 0 : getStringHashCode(this.s55_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.t55_1) | 0;
        result = imul(result, 31) + this.u55_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.v55_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Address()))
          return false;
        if (!(this.r55_1 === other.r55_1))
          return false;
        if (!(this.s55_1 == other.s55_1))
          return false;
        if (!(this.t55_1 === other.t55_1))
          return false;
        if (!this.u55_1.equals(other.u55_1))
          return false;
        if (!(this.v55_1 === other.v55_1))
          return false;
        return true;
      }
      static y9y(seen0, line1, line2, city, state, zipcode, serializationConstructorMarker) {
        Companion_getInstance_35();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_33().w9y_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.r55_1 = '';
        else
          $this.r55_1 = line1;
        if (0 === (seen0 & 2))
          $this.s55_1 = null;
        else
          $this.s55_1 = line2;
        if (0 === (seen0 & 4))
          $this.t55_1 = '';
        else
          $this.t55_1 = city;
        if (0 === (seen0 & 8))
          $this.u55_1 = State_Utah_getInstance();
        else
          $this.u55_1 = state;
        if (0 === (seen0 & 16))
          $this.v55_1 = '';
        else
          $this.v55_1 = zipcode;
        return $this;
      }
    }
    initMetadataForClass($, 'Address', Address, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_33});
    AddressClass = $;
  }
  return AddressClass;
}
function _MonetaryValueRange___init__impl__nk1fnc(rangeInUsCents) {
  return rangeInUsCents;
}
function _MonetaryValueRange___get_rangeInUsCents__impl__b74kqu($this) {
  return $this;
}
function _MonetaryValueRange___init__impl__nk1fnc_0(start, endInclusive) {
  return _MonetaryValueRange___init__impl__nk1fnc(new (LongRange())(_MonetaryValue___get_inUsCents__impl__icg2cu(start), _MonetaryValue___get_inUsCents__impl__icg2cu(endInclusive)));
}
function _MonetaryValueRange___get_start__impl__vz87xn($this) {
  return _MonetaryValue___init__impl__jsc11x(_MonetaryValueRange___get_rangeInUsCents__impl__b74kqu($this).rr_1);
}
function MonetaryValueRange___get_start__impl_iirwl($this) {
  return new (MonetaryValue())(_MonetaryValueRange___get_start__impl__vz87xn($this.a9z_1));
}
function _MonetaryValueRange___get_endInclusive__impl__m4ro0w($this) {
  return _MonetaryValue___init__impl__jsc11x(_MonetaryValueRange___get_rangeInUsCents__impl__b74kqu($this).sr_1);
}
function MonetaryValueRange___get_endInclusive__impl_px34tw($this) {
  return new (MonetaryValue())(_MonetaryValueRange___get_endInclusive__impl__m4ro0w($this.a9z_1));
}
function _MonetaryValueRange___get_endExclusive__impl__n5t4ya($this) {
  return _MonetaryValue___init__impl__jsc11x(_MonetaryValueRange___get_rangeInUsCents__impl__b74kqu($this).lr());
}
function MonetaryValueRange___get_endExclusive__impl_3u203i($this) {
  return new (MonetaryValue())(_MonetaryValueRange___get_endExclusive__impl__n5t4ya($this.a9z_1));
}
function MonetaryValueRange__contains_impl_7d4u17($this, value) {
  return _MonetaryValueRange___get_rangeInUsCents__impl__b74kqu($this).ur(_MonetaryValue___get_inUsCents__impl__icg2cu(value));
}
function MonetaryValueRange__contains_impl_7d4u17_0($this, value) {
  return MonetaryValueRange__contains_impl_7d4u17($this.a9z_1, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
}
function MonetaryValueRange__isEmpty_impl_g5mvfn($this) {
  return _MonetaryValueRange___get_rangeInUsCents__impl__b74kqu($this).i1();
}
function MonetaryValueRange__iterator_impl_b6296u($this) {
  return new (MonetaryValueRange$iterator$1())($this);
}
function MonetaryValueRange__toString_impl_eede0o($this) {
  return MonetaryValue__toString_impl_xslc77(_MonetaryValueRange___get_start__impl__vz87xn($this)) + '..' + MonetaryValue__toString_impl_xslc77(_MonetaryValueRange___get_endInclusive__impl__m4ro0w($this));
}
function MonetaryValueRange__hashCode_impl_yvkr5l($this) {
  return $this.hashCode();
}
function MonetaryValueRange__equals_impl_5o3p5h($this, other) {
  if (!(other instanceof MonetaryValueRange()))
    return false;
  var tmp0_other_with_cast = other.a9z_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var MonetaryValueRange$iterator$1Class;
function MonetaryValueRange$iterator$1() {
  if (MonetaryValueRange$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.b9z_1 = _MonetaryValueRange___get_rangeInUsCents__impl__b74kqu(this$0).m1();
      }
      n1() {
        return this.b9z_1.n1();
      }
      c9z() {
        return _MonetaryValue___init__impl__jsc11x(this.b9z_1.o1());
      }
      o1() {
        return new (MonetaryValue())(this.c9z());
      }
    }
    initMetadataForClass($);
    MonetaryValueRange$iterator$1Class = $;
  }
  return MonetaryValueRange$iterator$1Class;
}
var MonetaryValueRangeClass;
function MonetaryValueRange() {
  if (MonetaryValueRangeClass === VOID) {
    class $ {
      constructor(rangeInUsCents) {
        this.a9z_1 = rangeInUsCents;
      }
      d9z() {
        return _MonetaryValueRange___get_start__impl__vz87xn(this.a9z_1);
      }
      j1() {
        return MonetaryValueRange___get_start__impl_iirwl(this);
      }
      e9z() {
        return _MonetaryValueRange___get_endInclusive__impl__m4ro0w(this.a9z_1);
      }
      k1() {
        return MonetaryValueRange___get_endInclusive__impl_px34tw(this);
      }
      f9z() {
        return _MonetaryValueRange___get_endExclusive__impl__n5t4ya(this.a9z_1);
      }
      lr() {
        return MonetaryValueRange___get_endExclusive__impl_3u203i(this);
      }
      g9z(value) {
        return MonetaryValueRange__contains_impl_7d4u17(this.a9z_1, value);
      }
      l2(value) {
        return MonetaryValueRange__contains_impl_7d4u17_0(this, value);
      }
      i1() {
        return MonetaryValueRange__isEmpty_impl_g5mvfn(this.a9z_1);
      }
      m1() {
        return MonetaryValueRange__iterator_impl_b6296u(this.a9z_1);
      }
      toString() {
        return MonetaryValueRange__toString_impl_eede0o(this.a9z_1);
      }
      hashCode() {
        return MonetaryValueRange__hashCode_impl_yvkr5l(this.a9z_1);
      }
      equals(other) {
        return MonetaryValueRange__equals_impl_5o3p5h(this.a9z_1, other);
      }
    }
    initMetadataForClass($, 'MonetaryValueRange', VOID, VOID, [ClosedRange(), OpenEndRange(), Iterable()]);
    MonetaryValueRangeClass = $;
  }
  return MonetaryValueRangeClass;
}
function copy$default(scopeTitle, description, scopeSet, parentView, $super) {
  scopeTitle = scopeTitle === VOID ? this.d99() : scopeTitle;
  description = description === VOID ? this.q91() : description;
  scopeSet = scopeSet === VOID ? this.e99() : scopeSet;
  parentView = parentView === VOID ? this.f99() : parentView;
  return $super === VOID ? this.g99(scopeTitle, description, scopeSet, parentView) : $super.g99.call(this, scopeTitle, description, scopeSet, parentView);
}
var ScopeGroupClass;
function ScopeGroup() {
  if (ScopeGroupClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ScopeGroup', VOID, VOID, [HasId()]);
    ScopeGroupClass = $;
  }
  return ScopeGroupClass;
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.v8s_1.f2();
}
function TimerAction$Companion$_anonymous__4g41xo() {
  return createSimpleEnumSerializer('com.crowpay.TimerAction', values_3());
}
var TimerAction_CompleteLineItem_instance;
var TimerAction_AllowRaiseIssue_instance;
var TimerAction_ResumeAutoRelease_instance;
var TimerAction_AllowFileDispute_instance;
var TimerAction_AllowLockProject_instance;
var TimerAction_ReleasePayApp_instance;
var TimerAction_CompleteProject_instance;
function values_3() {
  return [TimerAction_CompleteLineItem_getInstance(), TimerAction_AllowRaiseIssue_getInstance(), TimerAction_ResumeAutoRelease_getInstance(), TimerAction_AllowFileDispute_getInstance(), TimerAction_AllowLockProject_getInstance(), TimerAction_ReleasePayApp_getInstance(), TimerAction_CompleteProject_getInstance()];
}
var CompanionClass_31;
function Companion_31() {
  if (CompanionClass_31 === VOID) {
    class $ {
      constructor() {
        Companion_instance_32 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.v8s_1 = lazy(tmp_0, TimerAction$Companion$_anonymous__4g41xo);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_3(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_31 = $;
  }
  return CompanionClass_31;
}
var Companion_instance_32;
function Companion_getInstance_36() {
  TimerAction_initEntries();
  if (Companion_instance_32 === VOID)
    new (Companion_31())();
  return Companion_instance_32;
}
var TimerAction_entriesInitialized;
function TimerAction_initEntries() {
  if (TimerAction_entriesInitialized)
    return Unit_instance;
  TimerAction_entriesInitialized = true;
  TimerAction_CompleteLineItem_instance = TimerAction().j9z('CompleteLineItem', 0);
  TimerAction_AllowRaiseIssue_instance = TimerAction().j9z('AllowRaiseIssue', 1);
  TimerAction_ResumeAutoRelease_instance = TimerAction().j9z('ResumeAutoRelease', 2);
  TimerAction_AllowFileDispute_instance = TimerAction().j9z('AllowFileDispute', 3);
  TimerAction_AllowLockProject_instance = TimerAction().j9z('AllowLockProject', 4);
  TimerAction_ReleasePayApp_instance = TimerAction().j9z('ReleasePayApp', 5);
  TimerAction_CompleteProject_instance = TimerAction().j9z('CompleteProject', 6);
  Companion_getInstance_36();
}
var TimerActionClass;
function TimerAction() {
  if (TimerActionClass === VOID) {
    class $ extends Enum() {
      static j9z(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'TimerAction', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_36});
    TimerActionClass = $;
  }
  return TimerActionClass;
}
function _get_$cachedSerializer__te6jhj_4($this) {
  return $this.w8s_1.f2();
}
function AlertCategory$Companion$_anonymous__tg5l4b() {
  return createSimpleEnumSerializer('com.crowpay.AlertCategory', values_4());
}
var AlertCategory_Info_instance;
var AlertCategory_ActionNeeded_instance;
var AlertCategory_CriticalActionNeeded_instance;
function values_4() {
  return [AlertCategory_Info_getInstance(), AlertCategory_ActionNeeded_getInstance(), AlertCategory_CriticalActionNeeded_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_4());
  return $ENTRIES;
}
var CompanionClass_32;
function Companion_32() {
  if (CompanionClass_32 === VOID) {
    class $ {
      constructor() {
        Companion_instance_33 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.w8s_1 = lazy(tmp_0, AlertCategory$Companion$_anonymous__tg5l4b);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_4(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_32 = $;
  }
  return CompanionClass_32;
}
var Companion_instance_33;
function Companion_getInstance_37() {
  AlertCategory_initEntries();
  if (Companion_instance_33 === VOID)
    new (Companion_32())();
  return Companion_instance_33;
}
var AlertCategory_entriesInitialized;
function AlertCategory_initEntries() {
  if (AlertCategory_entriesInitialized)
    return Unit_instance;
  AlertCategory_entriesInitialized = true;
  AlertCategory_Info_instance = AlertCategory().p9z('Info', 0, 'Info', '#f27c1c', 0);
  AlertCategory_ActionNeeded_instance = AlertCategory().p9z('ActionNeeded', 1, 'To-Do', '#f27c1c', 1);
  AlertCategory_CriticalActionNeeded_instance = AlertCategory().p9z('CriticalActionNeeded', 2, 'Concerns', '#f27c1c', 2);
  Companion_getInstance_37();
}
var $ENTRIES;
var AlertCategoryClass;
function AlertCategory() {
  if (AlertCategoryClass === VOID) {
    class $ extends Enum() {
      static p9z(name, ordinal, displayName, displayColor, priority) {
        var $this = this.c4(name, ordinal);
        $this.m9z_1 = displayName;
        $this.n9z_1 = displayColor;
        $this.o9z_1 = priority;
        return $this;
      }
      g90() {
        return this.m9z_1;
      }
      h90() {
        return this.n9z_1;
      }
      i90() {
        return this.o9z_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'AlertCategory', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_37});
    AlertCategoryClass = $;
  }
  return AlertCategoryClass;
}
function UserMembership$Companion$$childSerializers$_anonymous__lprb2v() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function UserMembership$Companion$$childSerializers$_anonymous__lprb2v_0() {
  return Companion_getInstance_1().m2a();
}
var CompanionClass_33;
function Companion_33() {
  if (CompanionClass_33 === VOID) {
    class $ {
      constructor() {
        Companion_instance_34 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, UserMembership$Companion$$childSerializers$_anonymous__lprb2v);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d8c_1 = [tmp_1, lazy(tmp_2, UserMembership$Companion$$childSerializers$_anonymous__lprb2v_0)];
      }
      m2a() {
        return $serializer_getInstance_34();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_33 = $;
  }
  return CompanionClass_33;
}
var Companion_instance_34;
function Companion_getInstance_38() {
  if (Companion_instance_34 === VOID)
    new (Companion_33())();
  return Companion_instance_34;
}
var $serializerClass_27;
function $serializer_27() {
  if ($serializerClass_27 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_27 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.UserMembership', this, 2);
        tmp0_serialDesc.c1b('contractor', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(Contractor())));
        tmp0_serialDesc.c1b('role', false);
        this.q9z_1 = tmp0_serialDesc;
      }
      r9z(encoder, value) {
        var tmp0_desc = this.q9z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_38().d8c_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.i8c_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.j8c_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r9z(encoder, value instanceof UserMembership() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q9z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_38().d8c_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return UserMembership().s9z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.q9z_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_38().d8c_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_27 = $;
  }
  return $serializerClass_27;
}
var $serializer_instance_27;
function $serializer_getInstance_34() {
  if ($serializer_instance_27 === VOID)
    new ($serializer_27())();
  return $serializer_instance_27;
}
var UserMembershipClass;
function UserMembership() {
  if (UserMembershipClass === VOID) {
    class $ {
      constructor(contractor, role) {
        Companion_getInstance_38();
        this.i8c_1 = contractor;
        this.j8c_1 = role;
      }
      t9z(contractor, role) {
        return new (UserMembership())(contractor, role);
      }
      l8c(contractor, role, $super) {
        contractor = contractor === VOID ? this.i8c_1 : contractor;
        role = role === VOID ? this.j8c_1 : role;
        return $super === VOID ? this.t9z(contractor, role) : $super.t9z.call(this, contractor, role);
      }
      toString() {
        return 'UserMembership(contractor=' + this.i8c_1.toString() + ', role=' + this.j8c_1.toString() + ')';
      }
      hashCode() {
        var result = this.i8c_1.hashCode();
        result = imul(result, 31) + this.j8c_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UserMembership()))
          return false;
        if (!this.i8c_1.equals(other.i8c_1))
          return false;
        if (!this.j8c_1.equals(other.j8c_1))
          return false;
        return true;
      }
      static s9z(seen0, contractor, role, serializationConstructorMarker) {
        Companion_getInstance_38();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_34().q9z_1);
        }
        var $this = createThis(this);
        $this.i8c_1 = contractor;
        $this.j8c_1 = role;
        return $this;
      }
    }
    initMetadataForClass($, 'UserMembership', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
    UserMembershipClass = $;
  }
  return UserMembershipClass;
}
var ManualClass;
function Manual() {
  if (ManualClass === VOID) {
    class $ {
      constructor(displayName) {
        this.u9z_1 = displayName;
      }
      g90() {
        return this.u9z_1;
      }
      toString() {
        return 'Manual(displayName=' + this.u9z_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.u9z_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Manual()))
          return false;
        if (!(this.u9z_1 === other.u9z_1))
          return false;
        return true;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Manual', VOID, VOID, [HasDisplayName()]);
    ManualClass = $;
  }
  return ManualClass;
}
function get_shortDisplayName() {
  return this.g90();
}
var HasDisplayNameClass;
function HasDisplayName() {
  if (HasDisplayNameClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HasDisplayName');
    HasDisplayNameClass = $;
  }
  return HasDisplayNameClass;
}
function get_withdrawn() {
  return null;
}
var ChangeRequestItemClass;
function ChangeRequestItem() {
  if (ChangeRequestItemClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ChangeRequestItem', VOID, VOID, [HasId()]);
    ChangeRequestItemClass = $;
  }
  return ChangeRequestItemClass;
}
function LineItemDispute$Companion$$childSerializers$_anonymous__fu10z7() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemDispute$Companion$$childSerializers$_anonymous__fu10z7_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_34;
function Companion_34() {
  if (CompanionClass_34 === VOID) {
    class $ {
      constructor() {
        Companion_instance_35 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LineItemDispute$Companion$$childSerializers$_anonymous__fu10z7);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g6j_1 = [tmp_1, lazy(tmp_2, LineItemDispute$Companion$$childSerializers$_anonymous__fu10z7_0), null];
      }
      m2a() {
        return $serializer_getInstance_35();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_34 = $;
  }
  return CompanionClass_34;
}
var Companion_instance_35;
function Companion_getInstance_39() {
  if (Companion_instance_35 === VOID)
    new (Companion_34())();
  return Companion_instance_35;
}
var $serializerClass_28;
function $serializer_28() {
  if ($serializerClass_28 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_28 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LineItemDispute', this, 3);
        tmp0_serialDesc.c1b('itemId', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItem())));
        tmp0_serialDesc.c1b('sourceMessage', false);
        tmp0_serialDesc.d1b(new (References())(getKClass(LineItemCompletionMessage())));
        tmp0_serialDesc.c1b('lineItemOnly', false);
        this.v9z_1 = tmp0_serialDesc;
      }
      w9z(encoder, value) {
        var tmp0_desc = this.v9z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_39().g6j_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.l6j_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.m6j_1);
        tmp1_output.s14(tmp0_desc, 2, value.n6j_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.w9z(encoder, value instanceof LineItemDispute() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v9z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_39().g6j_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.n13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.n13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return LineItemDispute().x9z(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.v9z_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_39().g6j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_28 = $;
  }
  return $serializerClass_28;
}
var $serializer_instance_28;
function $serializer_getInstance_35() {
  if ($serializer_instance_28 === VOID)
    new ($serializer_28())();
  return $serializer_instance_28;
}
var LineItemDisputeClass;
function LineItemDispute() {
  if (LineItemDisputeClass === VOID) {
    class $ {
      constructor(itemId, sourceMessage, lineItemOnly) {
        Companion_getInstance_39();
        this.l6j_1 = itemId;
        this.m6j_1 = sourceMessage;
        this.n6j_1 = lineItemOnly;
      }
      y9z(itemId, sourceMessage, lineItemOnly) {
        return new (LineItemDispute())(itemId, sourceMessage, lineItemOnly);
      }
      p6j(itemId, sourceMessage, lineItemOnly, $super) {
        itemId = itemId === VOID ? this.l6j_1 : itemId;
        sourceMessage = sourceMessage === VOID ? this.m6j_1 : sourceMessage;
        lineItemOnly = lineItemOnly === VOID ? this.n6j_1 : lineItemOnly;
        return $super === VOID ? this.y9z(itemId, sourceMessage, lineItemOnly) : $super.y9z.call(this, itemId, sourceMessage, lineItemOnly);
      }
      toString() {
        return 'LineItemDispute(itemId=' + this.l6j_1.toString() + ', sourceMessage=' + this.m6j_1.toString() + ', lineItemOnly=' + this.n6j_1 + ')';
      }
      hashCode() {
        var result = this.l6j_1.hashCode();
        result = imul(result, 31) + this.m6j_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.n6j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItemDispute()))
          return false;
        if (!this.l6j_1.equals(other.l6j_1))
          return false;
        if (!this.m6j_1.equals(other.m6j_1))
          return false;
        if (!(this.n6j_1 === other.n6j_1))
          return false;
        return true;
      }
      static x9z(seen0, itemId, sourceMessage, lineItemOnly, serializationConstructorMarker) {
        Companion_getInstance_39();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_35().v9z_1);
        }
        var $this = createThis(this);
        $this.l6j_1 = itemId;
        $this.m6j_1 = sourceMessage;
        $this.n6j_1 = lineItemOnly;
        return $this;
      }
    }
    initMetadataForClass($, 'LineItemDispute', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_35});
    LineItemDisputeClass = $;
  }
  return LineItemDisputeClass;
}
function LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_1() {
  return Companion_getInstance_3().m2a();
}
function LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_2() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_3() {
  var tmp = getKClass(Instant());
  var tmp_0 = get_nullable(InstantIso8601Serializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_4() {
  return new (ArrayListSerializer())($serializer_getInstance_7());
}
function LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_5() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return new (LinkedHashSetSerializer())(ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2));
}
var CompanionClass_35;
function Companion_35() {
  if (CompanionClass_35 === VOID) {
    class $ {
      constructor() {
        Companion_instance_36 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_9 = lazy(tmp_8, LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_3);
        var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_11 = lazy(tmp_10, LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_4);
        var tmp_12 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t8s_1 = [tmp_1, null, tmp_3, tmp_5, tmp_7, null, tmp_9, null, null, null, tmp_11, lazy(tmp_12, LineItemFromChangeRequest$Companion$$childSerializers$_anonymous__ncbskk_5), null];
      }
      m2a() {
        return $serializer_getInstance_36();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_35 = $;
  }
  return CompanionClass_35;
}
var Companion_instance_36;
function Companion_getInstance_40() {
  if (Companion_instance_36 === VOID)
    new (Companion_35())();
  return Companion_instance_36;
}
var $serializerClass_29;
function $serializer_29() {
  if ($serializerClass_29 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_29 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.LineItemFromChangeRequest', this, 13);
        tmp0_serialDesc.c1b('_id', false);
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('itemId', false);
        tmp0_serialDesc.c1b('changeType', false);
        tmp0_serialDesc.c1b('changeRequest', false);
        tmp0_serialDesc.c1b('itemNumber', false);
        tmp0_serialDesc.c1b('changeAccepted', false);
        tmp0_serialDesc.c1b('priceChange', false);
        tmp0_serialDesc.c1b('description', false);
        tmp0_serialDesc.c1b('price', false);
        tmp0_serialDesc.c1b('files', false);
        tmp0_serialDesc.c1b('readBy', true);
        tmp0_serialDesc.c1b('linked', true);
        this.z9z_1 = tmp0_serialDesc;
      }
      aa0(encoder, value) {
        var tmp0_desc = this.z9z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_40().t8s_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.ba0_1);
        tmp1_output.a15(tmp0_desc, 1, value.ca0_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.da0_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.ea0_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.fa0_1);
        tmp1_output.a15(tmp0_desc, 5, value.ga0_1);
        tmp1_output.d15(tmp0_desc, 6, tmp2_cached[6].f2(), value.ha0_1);
        tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance_6(), new (MonetaryValue())(value.ia0_1));
        tmp1_output.a15(tmp0_desc, 8, value.ja0_1);
        tmp1_output.c15(tmp0_desc, 9, $serializer_getInstance_6(), new (MonetaryValue())(value.ka0_1));
        tmp1_output.c15(tmp0_desc, 10, tmp2_cached[10].f2(), value.la0_1);
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !equals(value.ma0_1, emptySet())) {
          tmp1_output.c15(tmp0_desc, 11, tmp2_cached[11].f2(), value.ma0_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.na0_1 === false)) {
          tmp1_output.s14(tmp0_desc, 12, value.na0_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.aa0(encoder, value instanceof LineItemFromChangeRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z9z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = false;
        var tmp17_input = decoder.l13(tmp0_desc);
        var tmp18_cached = Companion_getInstance_40().t8s_1;
        if (tmp17_input.a14()) {
          tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, tmp18_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.x13(tmp0_desc, 2, tmp18_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.x13(tmp0_desc, 3, tmp18_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp17_input.x13(tmp0_desc, 4, tmp18_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp17_input.z13(tmp0_desc, 6, tmp18_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp = $serializer_getInstance_6();
          var tmp_0 = tmp11_local7;
          var tmp_1 = tmp17_input.x13(tmp0_desc, 7, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp11_local7 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp17_input.v13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          var tmp_2 = $serializer_getInstance_6();
          var tmp_3 = tmp13_local9;
          var tmp_4 = tmp17_input.x13(tmp0_desc, 9, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp13_local9 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp17_input.x13(tmp0_desc, 10, tmp18_cached[10].f2(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp17_input.x13(tmp0_desc, 11, tmp18_cached[11].f2(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp17_input.n13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, tmp18_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.x13(tmp0_desc, 2, tmp18_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.x13(tmp0_desc, 3, tmp18_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp17_input.x13(tmp0_desc, 4, tmp18_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp17_input.z13(tmp0_desc, 6, tmp18_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_5 = $serializer_getInstance_6();
                var tmp_6 = tmp11_local7;
                var tmp_7 = tmp17_input.x13(tmp0_desc, 7, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
                tmp11_local7 = tmp_7 == null ? null : tmp_7.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp17_input.v13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                var tmp_8 = $serializer_getInstance_6();
                var tmp_9 = tmp13_local9;
                var tmp_10 = tmp17_input.x13(tmp0_desc, 9, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
                tmp13_local9 = tmp_10 == null ? null : tmp_10.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp17_input.x13(tmp0_desc, 10, tmp18_cached[10].f2(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp17_input.x13(tmp0_desc, 11, tmp18_cached[11].f2(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp17_input.n13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp17_input.m13(tmp0_desc);
        return LineItemFromChangeRequest().oa0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      az() {
        return this.z9z_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_40().t8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), tmp0_cached[4].f2(), StringSerializer_getInstance(), get_nullable(tmp0_cached[6].f2()), $serializer_getInstance_6(), StringSerializer_getInstance(), $serializer_getInstance_6(), tmp0_cached[10].f2(), tmp0_cached[11].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_29 = $;
  }
  return $serializerClass_29;
}
var $serializer_instance_29;
function $serializer_getInstance_36() {
  if ($serializer_instance_29 === VOID)
    new ($serializer_29())();
  return $serializer_instance_29;
}
var LineItemFromChangeRequestClass;
function LineItemFromChangeRequest() {
  if (LineItemFromChangeRequestClass === VOID) {
    class $ {
      h40() {
        return this.ba0_1;
      }
      k20() {
        return this.ca0_1;
      }
      r94() {
        return this.da0_1;
      }
      z94() {
        return this.ea0_1;
      }
      q94() {
        return this.fa0_1;
      }
      w94() {
        return this.ga0_1;
      }
      x94() {
        return this.ha0_1;
      }
      f97() {
        return this.ia0_1;
      }
      u94() {
        return this.f97();
      }
      q91() {
        return this.ja0_1;
      }
      v91() {
        return this.ka0_1;
      }
      r91() {
        return this.la0_1;
      }
      t91() {
        return this.ma0_1;
      }
      s94() {
        return this.na0_1;
      }
      y94() {
        return null;
      }
      toString() {
        return 'LineItemFromChangeRequest(_id=' + this.ba0_1.toString() + ', name=' + this.ca0_1 + ', itemId=' + this.da0_1.toString() + ', changeType=' + this.ea0_1.toString() + ', changeRequest=' + this.fa0_1.toString() + ', itemNumber=' + this.ga0_1 + ', changeAccepted=' + toString_0(this.ha0_1) + ', priceChange=' + MonetaryValue__toString_impl_xslc77(this.ia0_1) + ', description=' + this.ja0_1 + ', price=' + MonetaryValue__toString_impl_xslc77(this.ka0_1) + ', files=' + toString(this.la0_1) + ', readBy=' + toString(this.ma0_1) + ')';
      }
      hashCode() {
        var result = this.ba0_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.ca0_1) | 0;
        result = imul(result, 31) + this.da0_1.hashCode() | 0;
        result = imul(result, 31) + this.ea0_1.hashCode() | 0;
        result = imul(result, 31) + this.fa0_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.ga0_1) | 0;
        result = imul(result, 31) + (this.ha0_1 == null ? 0 : this.ha0_1.hashCode()) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.ia0_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.ja0_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.ka0_1) | 0;
        result = imul(result, 31) + hashCode(this.la0_1) | 0;
        result = imul(result, 31) + hashCode(this.ma0_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItemFromChangeRequest()))
          return false;
        if (!this.ba0_1.equals(other.ba0_1))
          return false;
        if (!(this.ca0_1 === other.ca0_1))
          return false;
        if (!this.da0_1.equals(other.da0_1))
          return false;
        if (!this.ea0_1.equals(other.ea0_1))
          return false;
        if (!this.fa0_1.equals(other.fa0_1))
          return false;
        if (!(this.ga0_1 === other.ga0_1))
          return false;
        if (!equals(this.ha0_1, other.ha0_1))
          return false;
        if (!(this.ia0_1 === other.ia0_1))
          return false;
        if (!(this.ja0_1 === other.ja0_1))
          return false;
        if (!(this.ka0_1 === other.ka0_1))
          return false;
        if (!equals(this.la0_1, other.la0_1))
          return false;
        if (!equals(this.ma0_1, other.ma0_1))
          return false;
        return true;
      }
      static oa0(seen0, _id, name, itemId, changeType, changeRequest, itemNumber, changeAccepted, priceChange, description, price, files, readBy, linked, serializationConstructorMarker) {
        Companion_getInstance_40();
        if (!(2047 === (2047 & seen0))) {
          throwMissingFieldException(seen0, 2047, $serializer_getInstance_36().z9z_1);
        }
        var $this = createThis(this);
        $this.ba0_1 = _id;
        $this.ca0_1 = name;
        $this.da0_1 = itemId;
        $this.ea0_1 = changeType;
        $this.fa0_1 = changeRequest;
        $this.ga0_1 = itemNumber;
        $this.ha0_1 = changeAccepted;
        $this.ia0_1 = priceChange;
        $this.ja0_1 = description;
        $this.ka0_1 = price;
        $this.la0_1 = files;
        if (0 === (seen0 & 2048))
          $this.ma0_1 = emptySet();
        else
          $this.ma0_1 = readBy;
        if (0 === (seen0 & 4096))
          $this.na0_1 = false;
        else
          $this.na0_1 = linked;
        return $this;
      }
    }
    protoOf($).h95 = get_withdrawn;
    initMetadataForClass($, 'LineItemFromChangeRequest', VOID, VOID, [ChangeRequestItem(), LineItemInterface(), ReadByDataModel()], VOID, VOID, {0: $serializer_getInstance_36});
    LineItemFromChangeRequestClass = $;
  }
  return LineItemFromChangeRequestClass;
}
var ItemChangeInterfaceClass;
function ItemChangeInterface() {
  if (ItemChangeInterfaceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ItemChangeInterface');
    ItemChangeInterfaceClass = $;
  }
  return ItemChangeInterfaceClass;
}
function get_pending(_this__u8e3s4) {
  return _this__u8e3s4.x94() == null && _this__u8e3s4.y94() == null && _this__u8e3s4.h95() == null;
}
var DrawTableItemClass;
function DrawTableItem() {
  if (DrawTableItemClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DrawTableItem');
    DrawTableItemClass = $;
  }
  return DrawTableItemClass;
}
function SpecView$Companion$$childSerializers$_anonymous__v2qg4q() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function SpecView$Companion$$childSerializers$_anonymous__v2qg4q_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = get_nullable(DeferToContextualUuidSerializer_getInstance());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_36;
function Companion_36() {
  if (CompanionClass_36 === VOID) {
    class $ {
      constructor() {
        Companion_instance_37 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, SpecView$Companion$$childSerializers$_anonymous__v2qg4q);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h82_1 = [tmp_1, null, null, null, lazy(tmp_2, SpecView$Companion$$childSerializers$_anonymous__v2qg4q_0)];
      }
      m2a() {
        return $serializer_getInstance_37();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_36 = $;
  }
  return CompanionClass_36;
}
var Companion_instance_37;
function Companion_getInstance_41() {
  if (Companion_instance_37 === VOID)
    new (Companion_36())();
  return Companion_instance_37;
}
var $serializerClass_30;
function $serializer_30() {
  if ($serializerClass_30 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_30 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.SpecView', this, 5);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('description', true);
        tmp0_serialDesc.c1b('isSet', false);
        tmp0_serialDesc.c1b('parentView', true);
        this.pa0_1 = tmp0_serialDesc;
      }
      qa0(encoder, value) {
        var tmp0_desc = this.pa0_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_41().h82_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.o82_1);
        tmp1_output.a15(tmp0_desc, 1, value.p82_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.q82_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.q82_1);
        }
        tmp1_output.s14(tmp0_desc, 3, value.r82_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.s82_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.s82_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.qa0(encoder, value instanceof SpecView() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.pa0_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_41().h82_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.x13(tmp0_desc, 0, tmp10_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, tmp10_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return SpecView().ra0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.pa0_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_41().h82_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[4].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_30 = $;
  }
  return $serializerClass_30;
}
var $serializer_instance_30;
function $serializer_getInstance_37() {
  if ($serializer_instance_30 === VOID)
    new ($serializer_30())();
  return $serializer_instance_30;
}
var SpecViewClass;
function SpecView() {
  if (SpecViewClass === VOID) {
    class $ {
      constructor(_id, name, description, isSet, parentView) {
        Companion_getInstance_41();
        _id = _id === VOID ? Companion_getInstance_0().m2p() : _id;
        description = description === VOID ? null : description;
        parentView = parentView === VOID ? null : parentView;
        this.o82_1 = _id;
        this.p82_1 = name;
        this.q82_1 = description;
        this.r82_1 = isSet;
        this.s82_1 = parentView;
      }
      h40() {
        return this.o82_1;
      }
      q91() {
        return this.q82_1;
      }
      f99() {
        return this.s82_1;
      }
      e99() {
        return this.r82_1;
      }
      d99() {
        return this.p82_1;
      }
      g99(scopeTitle, description, scopeSet, parentView) {
        return this.u82(VOID, scopeTitle, description, scopeSet, parentView);
      }
      i9d(project, seed) {
        var tmp = combineWith(this.o82_1, project, seed);
        var tmp0_safe_receiver = this.s82_1;
        return new (ScopeView())(tmp, project, this.p82_1, this.q82_1, VOID, this.r82_1, tmp0_safe_receiver == null ? null : combineWith(tmp0_safe_receiver, project, seed));
      }
      sa0(_id, name, description, isSet, parentView) {
        return new (SpecView())(_id, name, description, isSet, parentView);
      }
      u82(_id, name, description, isSet, parentView, $super) {
        _id = _id === VOID ? this.o82_1 : _id;
        name = name === VOID ? this.p82_1 : name;
        description = description === VOID ? this.q82_1 : description;
        isSet = isSet === VOID ? this.r82_1 : isSet;
        parentView = parentView === VOID ? this.s82_1 : parentView;
        return $super === VOID ? this.sa0(_id, name, description, isSet, parentView) : $super.sa0.call(this, _id, name, description, isSet, parentView);
      }
      toString() {
        return 'SpecView(_id=' + this.o82_1.toString() + ', name=' + this.p82_1 + ', description=' + this.q82_1 + ', isSet=' + this.r82_1 + ', parentView=' + toString_0(this.s82_1) + ')';
      }
      hashCode() {
        var result = this.o82_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.p82_1) | 0;
        result = imul(result, 31) + (this.q82_1 == null ? 0 : getStringHashCode(this.q82_1)) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.r82_1) | 0;
        result = imul(result, 31) + (this.s82_1 == null ? 0 : this.s82_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpecView()))
          return false;
        if (!this.o82_1.equals(other.o82_1))
          return false;
        if (!(this.p82_1 === other.p82_1))
          return false;
        if (!(this.q82_1 == other.q82_1))
          return false;
        if (!(this.r82_1 === other.r82_1))
          return false;
        if (!equals(this.s82_1, other.s82_1))
          return false;
        return true;
      }
      static ra0(seen0, _id, name, description, isSet, parentView, serializationConstructorMarker) {
        Companion_getInstance_41();
        if (!(10 === (10 & seen0))) {
          throwMissingFieldException(seen0, 10, $serializer_getInstance_37().pa0_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.o82_1 = Companion_getInstance_0().m2p();
        else
          $this.o82_1 = _id;
        $this.p82_1 = name;
        if (0 === (seen0 & 4))
          $this.q82_1 = null;
        else
          $this.q82_1 = description;
        $this.r82_1 = isSet;
        if (0 === (seen0 & 16))
          $this.s82_1 = null;
        else
          $this.s82_1 = parentView;
        return $this;
      }
    }
    protoOf($).e80 = copy$default;
    initMetadataForClass($, 'SpecView', VOID, VOID, [HasId(), ScopeGroup()], VOID, VOID, {0: $serializer_getInstance_37});
    SpecViewClass = $;
  }
  return SpecViewClass;
}
function ClientFeedback$Companion$$childSerializers$_anonymous__7ku9y() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_37;
function Companion_37() {
  if (CompanionClass_37 === VOID) {
    class $ {
      constructor() {
        Companion_instance_38 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h5b_1 = [lazy(tmp_0, ClientFeedback$Companion$$childSerializers$_anonymous__7ku9y), null];
      }
      m2a() {
        return $serializer_getInstance_38();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_37 = $;
  }
  return CompanionClass_37;
}
var Companion_instance_38;
function Companion_getInstance_42() {
  if (Companion_instance_38 === VOID)
    new (Companion_37())();
  return Companion_instance_38;
}
var $serializerClass_31;
function $serializer_31() {
  if ($serializerClass_31 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_31 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ClientFeedback', this, 2);
        tmp0_serialDesc.c1b('at', true);
        tmp0_serialDesc.c1b('message', false);
        this.ta0_1 = tmp0_serialDesc;
      }
      ua0(encoder, value) {
        var tmp0_desc = this.ta0_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_42().h5b_1;
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).d1m();
          tmp = !value.o5b_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.o5b_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.p5b_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.ua0(encoder, value instanceof ClientFeedback() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.ta0_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_42().h5b_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ClientFeedback().va0(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.ta0_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_42().h5b_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_31 = $;
  }
  return $serializerClass_31;
}
var $serializer_instance_31;
function $serializer_getInstance_38() {
  if ($serializer_instance_31 === VOID)
    new ($serializer_31())();
  return $serializer_instance_31;
}
var ClientFeedbackClass;
function ClientFeedback() {
  if (ClientFeedbackClass === VOID) {
    class $ {
      constructor(at, message) {
        Companion_getInstance_42();
        var tmp;
        if (at === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).d1m();
        } else {
          tmp = at;
        }
        at = tmp;
        this.o5b_1 = at;
        this.p5b_1 = message;
      }
      wa0(at, message) {
        return new (ClientFeedback())(at, message);
      }
      r5b(at, message, $super) {
        at = at === VOID ? this.o5b_1 : at;
        message = message === VOID ? this.p5b_1 : message;
        return $super === VOID ? this.wa0(at, message) : $super.wa0.call(this, at, message);
      }
      toString() {
        return 'ClientFeedback(at=' + this.o5b_1.toString() + ', message=' + this.p5b_1 + ')';
      }
      hashCode() {
        var result = this.o5b_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.p5b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientFeedback()))
          return false;
        if (!this.o5b_1.equals(other.o5b_1))
          return false;
        if (!(this.p5b_1 === other.p5b_1))
          return false;
        return true;
      }
      static va0(seen0, at, message, serializationConstructorMarker) {
        Companion_getInstance_42();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_38().ta0_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.o5b_1 = get_default(Companion_instance).d1m();
        } else
          $this.o5b_1 = at;
        $this.p5b_1 = message;
        return $this;
      }
    }
    initMetadataForClass($, 'ClientFeedback', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_38});
    ClientFeedbackClass = $;
  }
  return ClientFeedbackClass;
}
var CompanionClass_38;
function Companion_38() {
  if (CompanionClass_38 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_39();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_38 = $;
  }
  return CompanionClass_38;
}
var Companion_instance_39;
function Companion_getInstance_43() {
  return Companion_instance_39;
}
var $serializerClass_32;
function $serializer_32() {
  if ($serializerClass_32 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_32 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.ChangeDenyRequest', this, 2);
        tmp0_serialDesc.c1b('hash', false);
        tmp0_serialDesc.c1b('feedback', true);
        this.xa0_1 = tmp0_serialDesc;
      }
      ya0(encoder, value) {
        var tmp0_desc = this.xa0_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.za0_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.aa1_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.aa1_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.ya0(encoder, value instanceof ChangeDenyRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.xa0_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ChangeDenyRequest().ba1(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.xa0_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_32 = $;
  }
  return $serializerClass_32;
}
var $serializer_instance_32;
function $serializer_getInstance_39() {
  if ($serializer_instance_32 === VOID)
    new ($serializer_32())();
  return $serializer_instance_32;
}
var ChangeDenyRequestClass;
function ChangeDenyRequest() {
  if (ChangeDenyRequestClass === VOID) {
    class $ {
      toString() {
        return 'ChangeDenyRequest(hash=' + this.za0_1 + ', feedback=' + this.aa1_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.za0_1);
        result = imul(result, 31) + (this.aa1_1 == null ? 0 : getStringHashCode(this.aa1_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChangeDenyRequest()))
          return false;
        if (!(this.za0_1 === other.za0_1))
          return false;
        if (!(this.aa1_1 == other.aa1_1))
          return false;
        return true;
      }
      static ba1(seen0, hash, feedback, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_39().xa0_1);
        }
        var $this = createThis(this);
        $this.za0_1 = hash;
        if (0 === (seen0 & 2))
          $this.aa1_1 = null;
        else
          $this.aa1_1 = feedback;
        return $this;
      }
    }
    initMetadataForClass($, 'ChangeDenyRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_39});
    ChangeDenyRequestClass = $;
  }
  return ChangeDenyRequestClass;
}
var CompanionClass_39;
function Companion_39() {
  if (CompanionClass_39 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_40();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_39 = $;
  }
  return CompanionClass_39;
}
var Companion_instance_40;
function Companion_getInstance_44() {
  return Companion_instance_40;
}
var $serializerClass_33;
function $serializer_33() {
  if ($serializerClass_33 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_33 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.EditPaymentInfoRequest', this, 2);
        tmp0_serialDesc.c1b('newBankName', false);
        tmp0_serialDesc.c1b('newAccountName', false);
        this.ca1_1 = tmp0_serialDesc;
      }
      da1(encoder, value) {
        var tmp0_desc = this.ca1_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.ea1_1);
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.fa1_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.da1(encoder, value instanceof EditPaymentInfoRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.ca1_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return EditPaymentInfoRequest().ga1(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.ca1_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_33 = $;
  }
  return $serializerClass_33;
}
var $serializer_instance_33;
function $serializer_getInstance_40() {
  if ($serializer_instance_33 === VOID)
    new ($serializer_33())();
  return $serializer_instance_33;
}
var EditPaymentInfoRequestClass;
function EditPaymentInfoRequest() {
  if (EditPaymentInfoRequestClass === VOID) {
    class $ {
      toString() {
        return 'EditPaymentInfoRequest(newBankName=' + this.ea1_1 + ', newAccountName=' + this.fa1_1 + ')';
      }
      hashCode() {
        var result = this.ea1_1 == null ? 0 : getStringHashCode(this.ea1_1);
        result = imul(result, 31) + (this.fa1_1 == null ? 0 : getStringHashCode(this.fa1_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EditPaymentInfoRequest()))
          return false;
        if (!(this.ea1_1 == other.ea1_1))
          return false;
        if (!(this.fa1_1 == other.fa1_1))
          return false;
        return true;
      }
      static ga1(seen0, newBankName, newAccountName, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_40().ca1_1);
        }
        var $this = createThis(this);
        $this.ea1_1 = newBankName;
        $this.fa1_1 = newAccountName;
        return $this;
      }
    }
    initMetadataForClass($, 'EditPaymentInfoRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_40});
    EditPaymentInfoRequestClass = $;
  }
  return EditPaymentInfoRequestClass;
}
function HashWithID$Companion$$childSerializers$_anonymous__yny1i3() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_40;
function Companion_40() {
  if (CompanionClass_40 === VOID) {
    class $ {
      constructor() {
        Companion_instance_41 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u8s_1 = [lazy(tmp_0, HashWithID$Companion$$childSerializers$_anonymous__yny1i3), null];
      }
      m2a() {
        return $serializer_getInstance_41();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_40 = $;
  }
  return CompanionClass_40;
}
var Companion_instance_41;
function Companion_getInstance_45() {
  if (Companion_instance_41 === VOID)
    new (Companion_40())();
  return Companion_instance_41;
}
var $serializerClass_34;
function $serializer_34() {
  if ($serializerClass_34 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_34 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.HashWithID', this, 2);
        tmp0_serialDesc.c1b('_id', false);
        tmp0_serialDesc.c1b('hash', false);
        this.ha1_1 = tmp0_serialDesc;
      }
      ia1(encoder, value) {
        var tmp0_desc = this.ha1_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_45().u8s_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.ja1_1);
        tmp1_output.a15(tmp0_desc, 1, value.ka1_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.ia1(encoder, value instanceof HashWithID() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.ha1_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_45().u8s_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return HashWithID().la1(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.ha1_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_45().u8s_1[0].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_34 = $;
  }
  return $serializerClass_34;
}
var $serializer_instance_34;
function $serializer_getInstance_41() {
  if ($serializer_instance_34 === VOID)
    new ($serializer_34())();
  return $serializer_instance_34;
}
var HashWithIDClass;
function HashWithID() {
  if (HashWithIDClass === VOID) {
    class $ {
      h40() {
        return this.ja1_1;
      }
      toString() {
        return 'HashWithID(_id=' + this.ja1_1.toString() + ', hash=' + this.ka1_1 + ')';
      }
      hashCode() {
        var result = this.ja1_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.ka1_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HashWithID()))
          return false;
        if (!this.ja1_1.equals(other.ja1_1))
          return false;
        if (!(this.ka1_1 === other.ka1_1))
          return false;
        return true;
      }
      static la1(seen0, _id, hash, serializationConstructorMarker) {
        Companion_getInstance_45();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_41().ha1_1);
        }
        var $this = createThis(this);
        $this.ja1_1 = _id;
        $this.ka1_1 = hash;
        return $this;
      }
    }
    initMetadataForClass($, 'HashWithID', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_41});
    HashWithIDClass = $;
  }
  return HashWithIDClass;
}
function EmailData$Companion$$childSerializers$_anonymous__gslrss() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), StringSerializer_getInstance());
}
var CompanionClass_41;
function Companion_41() {
  if (CompanionClass_41 === VOID) {
    class $ {
      constructor() {
        Companion_instance_42 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s5y_1 = [null, null, lazy(tmp_0, EmailData$Companion$$childSerializers$_anonymous__gslrss)];
      }
      m2a() {
        return $serializer_getInstance_42();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_41 = $;
  }
  return CompanionClass_41;
}
var Companion_instance_42;
function Companion_getInstance_46() {
  if (Companion_instance_42 === VOID)
    new (Companion_41())();
  return Companion_instance_42;
}
var $serializerClass_35;
function $serializer_35() {
  if ($serializerClass_35 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_35 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.EmailData', this, 3);
        tmp0_serialDesc.c1b('templateFile', false);
        tmp0_serialDesc.c1b('subjectLine', false);
        tmp0_serialDesc.c1b('variables', false);
        this.ma1_1 = tmp0_serialDesc;
      }
      na1(encoder, value) {
        var tmp0_desc = this.ma1_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_46().s5y_1;
        tmp1_output.a15(tmp0_desc, 0, value.x5y_1);
        tmp1_output.a15(tmp0_desc, 1, value.y5y_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.z5y_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.na1(encoder, value instanceof EmailData() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.ma1_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_46().s5y_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return EmailData().oa1(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.ma1_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_46().s5y_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_35 = $;
  }
  return $serializerClass_35;
}
var $serializer_instance_35;
function $serializer_getInstance_42() {
  if ($serializer_instance_35 === VOID)
    new ($serializer_35())();
  return $serializer_instance_35;
}
var EmailDataClass;
function EmailData() {
  if (EmailDataClass === VOID) {
    class $ {
      constructor(templateFile, subjectLine, variables) {
        Companion_getInstance_46();
        this.x5y_1 = templateFile;
        this.y5y_1 = subjectLine;
        this.z5y_1 = variables;
      }
      pa1(templateFile, subjectLine, variables) {
        return new (EmailData())(templateFile, subjectLine, variables);
      }
      b5z(templateFile, subjectLine, variables, $super) {
        templateFile = templateFile === VOID ? this.x5y_1 : templateFile;
        subjectLine = subjectLine === VOID ? this.y5y_1 : subjectLine;
        variables = variables === VOID ? this.z5y_1 : variables;
        return $super === VOID ? this.pa1(templateFile, subjectLine, variables) : $super.pa1.call(this, templateFile, subjectLine, variables);
      }
      toString() {
        return 'EmailData(templateFile=' + this.x5y_1 + ', subjectLine=' + this.y5y_1 + ', variables=' + toString(this.z5y_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.x5y_1);
        result = imul(result, 31) + getStringHashCode(this.y5y_1) | 0;
        result = imul(result, 31) + hashCode(this.z5y_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmailData()))
          return false;
        if (!(this.x5y_1 === other.x5y_1))
          return false;
        if (!(this.y5y_1 === other.y5y_1))
          return false;
        if (!equals(this.z5y_1, other.z5y_1))
          return false;
        return true;
      }
      static oa1(seen0, templateFile, subjectLine, variables, serializationConstructorMarker) {
        Companion_getInstance_46();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_42().ma1_1);
        }
        var $this = createThis(this);
        $this.x5y_1 = templateFile;
        $this.y5y_1 = subjectLine;
        $this.z5y_1 = variables;
        return $this;
      }
    }
    initMetadataForClass($, 'EmailData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_42});
    EmailDataClass = $;
  }
  return EmailDataClass;
}
var CompanionClass_42;
function Companion_42() {
  if (CompanionClass_42 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_43();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_42 = $;
  }
  return CompanionClass_42;
}
var Companion_instance_43;
function Companion_getInstance_47() {
  return Companion_instance_43;
}
var $serializerClass_36;
function $serializer_36() {
  if ($serializerClass_36 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_36 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.SetupFailed', this, 4);
        tmp0_serialDesc.c1b('_id', false);
        tmp0_serialDesc.c1b('intent', false);
        tmp0_serialDesc.c1b('customer', false);
        tmp0_serialDesc.c1b('cancelReason', false);
        this.qa1_1 = tmp0_serialDesc;
      }
      ra1(encoder, value) {
        var tmp0_desc = this.qa1_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.s81_1);
        tmp1_output.a15(tmp0_desc, 1, value.t81_1);
        tmp1_output.a15(tmp0_desc, 2, value.u81_1);
        tmp1_output.a15(tmp0_desc, 3, value.v81_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.ra1(encoder, value instanceof SetupFailed() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.qa1_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return SetupFailed().sa1(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.qa1_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_36 = $;
  }
  return $serializerClass_36;
}
var $serializer_instance_36;
function $serializer_getInstance_43() {
  if ($serializer_instance_36 === VOID)
    new ($serializer_36())();
  return $serializer_instance_36;
}
var SetupFailedClass;
function SetupFailed() {
  if (SetupFailedClass === VOID) {
    class $ {
      constructor(_id, intent, customer, cancelReason) {
        this.s81_1 = _id;
        this.t81_1 = intent;
        this.u81_1 = customer;
        this.v81_1 = cancelReason;
      }
      h40() {
        return this.s81_1;
      }
      ta1(_id, intent, customer, cancelReason) {
        return new (SetupFailed())(_id, intent, customer, cancelReason);
      }
      x81(_id, intent, customer, cancelReason, $super) {
        _id = _id === VOID ? this.s81_1 : _id;
        intent = intent === VOID ? this.t81_1 : intent;
        customer = customer === VOID ? this.u81_1 : customer;
        cancelReason = cancelReason === VOID ? this.v81_1 : cancelReason;
        return $super === VOID ? this.ta1(_id, intent, customer, cancelReason) : $super.ta1.call(this, _id, intent, customer, cancelReason);
      }
      toString() {
        return 'SetupFailed(_id=' + this.s81_1 + ', intent=' + this.t81_1 + ', customer=' + this.u81_1 + ', cancelReason=' + this.v81_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.s81_1);
        result = imul(result, 31) + getStringHashCode(this.t81_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u81_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v81_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetupFailed()))
          return false;
        if (!(this.s81_1 === other.s81_1))
          return false;
        if (!(this.t81_1 === other.t81_1))
          return false;
        if (!(this.u81_1 === other.u81_1))
          return false;
        if (!(this.v81_1 === other.v81_1))
          return false;
        return true;
      }
      static sa1(seen0, _id, intent, customer, cancelReason, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_43().qa1_1);
        }
        var $this = createThis(this);
        $this.s81_1 = _id;
        $this.t81_1 = intent;
        $this.u81_1 = customer;
        $this.v81_1 = cancelReason;
        return $this;
      }
    }
    initMetadataForClass($, 'SetupFailed', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_43});
    SetupFailedClass = $;
  }
  return SetupFailedClass;
}
function TimerAction_CompleteLineItem_getInstance() {
  TimerAction_initEntries();
  return TimerAction_CompleteLineItem_instance;
}
function TimerAction_AllowRaiseIssue_getInstance() {
  TimerAction_initEntries();
  return TimerAction_AllowRaiseIssue_instance;
}
function TimerAction_ResumeAutoRelease_getInstance() {
  TimerAction_initEntries();
  return TimerAction_ResumeAutoRelease_instance;
}
function TimerAction_AllowFileDispute_getInstance() {
  TimerAction_initEntries();
  return TimerAction_AllowFileDispute_instance;
}
function TimerAction_AllowLockProject_getInstance() {
  TimerAction_initEntries();
  return TimerAction_AllowLockProject_instance;
}
function TimerAction_ReleasePayApp_getInstance() {
  TimerAction_initEntries();
  return TimerAction_ReleasePayApp_instance;
}
function TimerAction_CompleteProject_getInstance() {
  TimerAction_initEntries();
  return TimerAction_CompleteProject_instance;
}
function AlertCategory_Info_getInstance() {
  AlertCategory_initEntries();
  return AlertCategory_Info_instance;
}
function AlertCategory_ActionNeeded_getInstance() {
  AlertCategory_initEntries();
  return AlertCategory_ActionNeeded_instance;
}
function AlertCategory_CriticalActionNeeded_getInstance() {
  AlertCategory_initEntries();
  return AlertCategory_CriticalActionNeeded_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_9 = new (Companion_8())();
Companion_instance_12 = new (Companion_11())();
Companion_instance_13 = new (Companion_12())();
Companion_instance_14 = new (Companion_13())();
Companion_instance_18 = new (Companion_17())();
Companion_instance_19 = new (Companion_18())();
Companion_instance_26 = new (Companion_25())();
Companion_instance_30 = new (Companion_29())();
Companion_instance_39 = new (Companion_38())();
Companion_instance_40 = new (Companion_39())();
Companion_instance_43 = new (Companion_42())();
//endregion
//region block: exports
export {
  AccessAndFeedback as AccessAndFeedback14j91frzc8fa0,
  AccessInfo as AccessInfoj60d6hx1qs8r,
  AddUserToMembership as AddUserToMembership17wfynuguc0xh,
  Address as Addresscpovxna1tjmg,
  get_entries as get_entries2aa2t2vhorajh,
  AlertCategory as AlertCategory2i9ic5ekxmxrh,
  AnonymousProjectInfo as AnonymousProjectInfo3pqkdqm16et5a,
  ChangeRequestInfo as ChangeRequestInfo190hcn8381h6v,
  get_withdrawn as get_withdrawn1jcms7jq46kqk,
  ChangeRequestItem as ChangeRequestItem25pmay5za3qvv,
  ClientFeedback as ClientFeedback208nr9qsd3d5f,
  CompletionRequest as CompletionRequest2ew7c02dda2ep,
  Credit as Creditv1m3yq08fl3i,
  CrowPayAlert as CrowPayAlertxsn5n3sp58h5,
  VerificationRequest as VerificationRequest3eeavldn6rk90,
  DrawTableItem as DrawTableItemvon7hn1chfhu,
  EmailAddressWithName as EmailAddressWithName1kgo9tfobddjb,
  EmailData as EmailData2csvvu2p1bk3b,
  FiledForArbitration as FiledForArbitrationrkri4vx0h6kh,
  Manual as Manual3lg0s0ycvhhh4,
  get_shortDisplayName as get_shortDisplayNamenwyz2dxtvf5g,
  HasDisplayName as HasDisplayName3s4kfsms5h38b,
  HashAndFeedback as HashAndFeedback2e8ptt71irxk8,
  HashAndManyFeedback as HashAndManyFeedback2qtcgu6w92gzs,
  IdAndFeedback as IdAndFeedback5bkoyzmnn7cz,
  Issue as Issue1fn0d1tovjb9y,
  ItemChangeInterface as ItemChangeInterface3dt2mjp367emm,
  LineItemDispute as LineItemDispute2w87ksbqzbvuq,
  LineItemFromChangeRequest as LineItemFromChangeRequest29s1k7nucgyuu,
  LineItemInterface as LineItemInterface2ct3y0vtnbxod,
  LoginEmailRequest as LoginEmailRequest1l3a375d4eoce,
  MonetaryValueRange as MonetaryValueRange11s1xggovqdso,
  MonetaryValue as MonetaryValue3pm7jom4inigc,
  PaymentSetupRequest as PaymentSetupRequest2e2ymiizrwril,
  PendingCashOut as PendingCashOutimavqmg4ecmt,
  ProjectAttachment as ProjectAttachmentv4m5lkl2nz8g,
  RegisterContractor as RegisterContractortxxdpjweklvo,
  RegisterUser as RegisterUser77vi01gsji2g,
  ScopeGroup as ScopeGroupsc04cnao6ys4,
  SetupFailed as SetupFailed2fc202771pbwx,
  SpecView as SpecViewgfdgv6h7w5ti,
  TimerAction as TimerAction2lzic48mzpw2s,
  UserMembership as UserMembership38xnkdta6uihl,
  get_pending as get_pending3bzoyvzwzq8kn,
  AlertCategory_ActionNeeded_getInstance as AlertCategory_ActionNeeded_getInstanceuzezzg1ziuki,
  AlertCategory_CriticalActionNeeded_getInstance as AlertCategory_CriticalActionNeeded_getInstanceh77hzcy879hu,
  AlertCategory_Info_getInstance as AlertCategory_Info_getInstance3jt06v3o3bnmb,
  AdminVerification_Rejected_getInstance as AdminVerification_Rejected_getInstance34sgzpx9e5upn,
  AdminVerification_Verified_getInstance as AdminVerification_Verified_getInstance2j4n83c8vxcj0,
  DirectStatus_AmountVerification_getInstance as DirectStatus_AmountVerification_getInstanceorpj6tw48l74,
  DirectStatus_DescriptorVerification_getInstance as DirectStatus_DescriptorVerification_getInstance1kl5jqi32byal,
  DirectStatus_Failed_getInstance as DirectStatus_Failed_getInstance3unypatz9ynbl,
  DirectStatus_Verified_getInstance as DirectStatus_Verified_getInstancew10gjsxm5l1j,
  OwnerStatus_Success_getInstance as OwnerStatus_Success_getInstancebzl48656m87y,
  Flavor_ContractorRegistration_getInstance as Flavor_ContractorRegistration_getInstancegyu38r35kycq,
  Flavor_HomeownerRegistration_getInstance as Flavor_HomeownerRegistration_getInstance259ch7dnofaj1,
  TimerAction_AllowLockProject_getInstance as TimerAction_AllowLockProject_getInstance3xutugx5am7q,
  TimerAction_CompleteLineItem_getInstance as TimerAction_CompleteLineItem_getInstance3bxbacatbrybs,
  copy$default as copy$defaultre0p5zwdb0iv,
  _MonetaryValue___init__impl__jsc11x as _MonetaryValue___init__impl__jsc11x21b8u6q6nd7yd,
  _MonetaryValue___get_absoluteValue__impl__hjldkw as _MonetaryValue___get_absoluteValue__impl__hjldkw3vj23mkf30f7c,
  MonetaryValue__compareTo_impl_w7ul1r as MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h,
  MonetaryValue__div_impl_3meibk as MonetaryValue__div_impl_3meibk17hx1lxlelhgh,
  MonetaryValue__div_impl_3meibk_0 as MonetaryValue__div_impl_3meibk3mb2kbjjy06qs,
  MonetaryValue__hashCode_impl_fhcsz2 as MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh,
  _MonetaryValue___get_inUsCents__impl__icg2cu as _MonetaryValue___get_inUsCents__impl__icg2cu1ffzqvrb4rbpl,
  _MonetaryValue___get_inUsDollars__impl__m6itgm as _MonetaryValue___get_inUsDollars__impl__m6itgm2hb63k79x57s7,
  MonetaryValue__minus_impl_jw9qyp as MonetaryValue__minus_impl_jw9qyp323r7b11udph7,
  MonetaryValue__plus_impl_c1ylt as MonetaryValue__plus_impl_c1ylt2px1svctotw0g,
  MonetaryValue__rangeTo_impl_1k0odj as MonetaryValue__rangeTo_impl_1k0odj1ncwos3p2ntha,
  MonetaryValue__times_impl_hlr6p7 as MonetaryValue__times_impl_hlr6p71hn0xcq6so58l,
  MonetaryValue__times_impl_hlr6p7_0 as MonetaryValue__times_impl_hlr6p72nff9ykdm2zvo,
  MonetaryValue__times_impl_hlr6p7_1 as MonetaryValue__times_impl_hlr6p73k8qwiemwou4p,
  MonetaryValue__toFullString_impl_igjjwy as MonetaryValue__toFullString_impl_igjjwy52pd76w4j0ou,
  MonetaryValue__toStringAbsolute_impl_uovmiu as MonetaryValue__toStringAbsolute_impl_uovmiublgrzadk0gpl,
  MonetaryValue__toString_impl_xslc77 as MonetaryValue__toString_impl_xslc771noy15rjps4pw,
  MonetaryValue__unaryMinus_impl_x5smq0 as MonetaryValue__unaryMinus_impl_x5smq036mvwk2sni6rt,
  MonetaryValueRange__contains_impl_7d4u17 as MonetaryValueRange__contains_impl_7d4u172030w1fl7pfl7,
  _MonetaryValueRange___get_endInclusive__impl__m4ro0w as _MonetaryValueRange___get_endInclusive__impl__m4ro0w3vpy6nx062q23,
  _MonetaryValueRange___get_start__impl__vz87xn as _MonetaryValueRange___get_start__impl__vz87xnkvecqhn75yl7,
  MonetaryValueRange__toString_impl_eede0o as MonetaryValueRange__toString_impl_eede0o29kkga5u337ce,
  $serializer_getInstance_29 as $serializer_getInstancelpjkd3aykg3n,
  Companion_getInstance_31 as Companion_getInstance1tv6bohtg8v20,
  $serializer_getInstance_30 as $serializer_getInstancet3nsskmepj66,
  Companion_getInstance_32 as Companion_getInstance1twm7uvvfawb7,
  Companion_getInstance_27 as Companion_getInstance2vq5qbtte0dqu,
  $serializer_getInstance_33 as $serializer_getInstance1wv5hjws0bfh6,
  Companion_getInstance_35 as Companion_getInstance3snrp0mvkuou8,
  Companion_getInstance_37 as Companion_getInstance3w82ho14xgrz,
  Companion_getInstance_24 as Companion_getInstance2m9opt1pp6vj6,
  Companion_instance_39 as Companion_instance3d4t1ayx8gev1,
  $serializer_getInstance_31 as $serializer_getInstancegem3nsjl63vn,
  Companion_getInstance_33 as Companion_getInstance3newi3yfn54ei,
  $serializer_getInstance_38 as $serializer_getInstancempe4dljrfaa1,
  Companion_getInstance_42 as Companion_getInstance95jshvyfe4f5,
  $serializer_getInstance_25 as $serializer_getInstancephvhog69rda1,
  Companion_getInstance_26 as Companion_getInstance1am9aucrot1gq,
  $serializer_getInstance_18 as $serializer_getInstance1m1pty9fgkr0g,
  Companion_getInstance_19 as Companion_getInstance3dtgneissrfcv,
  Companion_getInstance_20 as Companion_getInstancem5ekhykter02,
  Companion_getInstance_12 as Companion_getInstance30yubwp5g6mt7,
  Companion_instance_9 as Companion_instance3pg67jx8dhjow,
  Companion_getInstance_9 as Companion_getInstancew45eaidw2uv,
  Companion_getInstance_15 as Companion_getInstance1rq8nd060y61d,
  Companion_getInstance_7 as Companion_getInstance3np43kcxu1zz,
  Companion_getInstance_11 as Companion_getInstance1zugja4gs8z3u,
  Companion_getInstance_14 as Companion_getInstanceutfzi4qvx3rh,
  Companion_getInstance_8 as Companion_getInstance2rck9zq8d70cs,
  Companion_getInstance_10 as Companion_getInstance6uhn60p4e96h,
  Companion_instance_40 as Companion_instance3tofa634sddcx,
  Companion_instance_19 as Companion_instance1n8yqmuuwqhm2,
  Companion_getInstance_46 as Companion_getInstance10mviaqk2elyr,
  $serializer_getInstance_24 as $serializer_getInstance24oainjoildlv,
  Companion_getInstance_25 as Companion_getInstance3mwnn7es55j4h,
  Companion_instance_18 as Companion_instancem42ud6s3tl46,
  Companion_getInstance_6 as Companion_getInstance3nuke4pai11e0,
  Companion_getInstance_45 as Companion_getInstance1cbscub8vwbod,
  Companion_getInstance_21 as Companion_getInstance24elb6i7hza1u,
  $serializer_getInstance_32 as $serializer_getInstance3fydoi3p4w54x,
  Companion_instance_30 as Companion_instancet9lyvx4dyg0w,
  $serializer_getInstance_35 as $serializer_getInstance5xj5u9f3kifs,
  Companion_getInstance_39 as Companion_getInstance2aw7vbmm2h3t7,
  Companion_getInstance_40 as Companion_getInstanceam0xkkf9ek,
  Companion_getInstance_29 as Companion_getInstanceop74a2t78ktp,
  Companion_getInstance_28 as Companion_getInstance18b2ua6mxmxtg,
  $serializer_getInstance_6 as $serializer_getInstance3qhgvjcaya2da,
  Companion_instance_0 as Companion_instance357q0zxkn8vu9,
  Companion_instance_12 as Companion_instance1jgtwyaz4kdue,
  Companion_instance_13 as Companion_instance2323gbvzg2l6b,
  $serializer_getInstance_7 as $serializer_getInstance3n2rtjb4no11s,
  Companion_getInstance_5 as Companion_getInstanceus6z4605rk5c,
  Companion_instance_14 as Companion_instance1jr11iungn4qh,
  Companion_instance_26 as Companion_instance7oj7gdhawh9q,
  Companion_instance_43 as Companion_instance204uo7fmjm4u6,
  $serializer_getInstance_37 as $serializer_getInstance3ili9vinccewy,
  Companion_getInstance_41 as Companion_getInstance1ymmu806vd2tw,
  Companion_getInstance_36 as Companion_getInstance3c3yiwvq39b64,
  $serializer_getInstance_34 as $serializer_getInstance36u72gmfjreba,
  Companion_getInstance_38 as Companion_getInstance29f2rub45de3p,
};
//endregion

//# sourceMappingURL=supportModels.mjs.map
